import React, {useEffect, useMemo, useRef, useState} from 'react';
import {useSearchParams} from "react-router-dom";
import {DataTable} from 'primereact/datatable';
import {Column, ColumnFilterElementTemplateOptions} from 'primereact/column';
import {classNames} from "primereact/utils";
import {Badge} from "primereact/badge";
import {Button} from "primereact/button";
import 'react-h5-audio-player/lib/styles.css';
import {Dialog} from "primereact/dialog";
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {Paginator} from "primereact/paginator";
import {MultiSelect} from "primereact/multiselect";
import {Calendar} from "primereact/calendar";
import {UPLOAD_AUDIO_LOADING} from "../../../redux/types/types";
import {DataRow} from "../../../types/types";
import {formatBranchDisplayLabel} from "../../../utils/formatBranchDisplayLabel";
import {getAllSimpleUsers} from "../../../redux/api/api";
import {
    clearStatisticDashboard,
    getEventStatisticToUserDetail,
    getStatisticDashboard,
    getStatisticsUserSortFields,
    getStatisticsWithPaginationFilterAndSorting
} from "../../../redux/api/apiStatisticsList";
import {
    setStatisticsCurrentPage,
    setStatisticsCurrentPageSize,
    setStatisticsFilter,
    setStatisticsUiFilters
} from "../../../redux/actions/actionsStatisticsList";
import {
    getCampaignFilterList
} from "../../../redux/api/apiMonitoringList";
import {getUsersManagerUserBranchesData} from "../../../redux/api/apiUsersList";
import {getAudioUrlForPlayer, setAudioUnavailable} from "../../../redux/actions/actionsMonitoringList";
import StatisticsListNav from "./StatisticsListNav";
import StatisticsListDetails from "./StatisticsListDetails";
import {GET_STATISTICS} from "../../../redux/types/typesStatisticsList";
import {resetAllStatisticFilters, updateStatisticFilter} from "../../../redux/actions/actionsCallsStatistics";
import {InputText} from "primereact/inputtext";
import {withStatisticsBranchIdSortField} from "../../../redux/api/sortFieldsFetchState";
import {
    areSearchParamsEqual,
    buildStatisticsSearchParams,
    readInitialStatisticsUrlState
} from "../../../utils/statisticsUrlState";
import {getHashPath} from "../../../utils/encodedUrlQuery";

const StatisticsList = (props: any) => {
    const dispatch = useAppDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const [initialStatisticsUrlState] = useState(readInitialStatisticsUrlState);
    const statisticsList = useAppSelector(state => state.StatisticsListReducer?.statisticsList);
    const userStatisticSortFields: any = useAppSelector(state => state.RolesReducer.userStatisticSortFields);
    const statisticSortFields = useMemo(
        () => withStatisticsBranchIdSortField(userStatisticSortFields),
        [userStatisticSortFields]
    );
    const campaignList = useAppSelector(state => state.MonitoringListReducer?.campaignListName);
    const branches = useAppSelector(state => state.UsersListReducer.branches);
    const statisticData = useAppSelector(state => state.StatisticsListReducer?.statisticData);
    const paginationSize = useAppSelector(state => state.StatisticsListReducer.paginationSize);
    const pagination = useAppSelector(state => state.StatisticsListReducer.pagination);
    const loader = useAppSelector(state => state.StatisticsListReducer.loading);
    const paginationPage = useAppSelector(state => state.StatisticsListReducer.paginationPage);
    const statusDictionary = useAppSelector(state => state.MonitoringListReducer.statusDictionary);
    const callResetDictionary = useAppSelector(state => state.MonitoringListReducer.callResetDictionary);
    const forcedClosingDictionary = useAppSelector(state => state.MonitoringListReducer.forcedClosingDictionary);
    const ownerTypeDictionary = useAppSelector(state => state.MonitoringListReducer.ownerTypeDictionary);
    const clearFilters = useAppSelector(state => state.StatisticsListReducer.clearFilters)
    const user = useAppSelector(state => state.UsersReducer.userData);
    // @ts-ignore
    const activeClick = useAppSelector(state => state.UsersListReducer.activeClick);
    const [first, setFirst] = useState(() => (initialStatisticsUrlState.page - 1) * initialStatisticsUrlState.size);
    const [selectedRowData, setSelectedRowData] = useState<any | null>(null);
    const [selectedRowExpansion, setSelectedRowExpansion] = useState<any | null>(null);
    const [selectedSessionRowExpansion] = useState<any | null>(null);
    const [selectedBSessionRowExpansion] = useState<any | null>(null);
    const [orderBy, setOrderBy] = useState<any>(initialStatisticsUrlState.orderBy);
    const [isDescFilter, setIsDescFilter] = useState<boolean>(initialStatisticsUrlState.isDesc);
    const [sortOrder, setSortOrder] = useState<number>(initialStatisticsUrlState.sortOrder);
    const [startTime, setStartTime] = useState<any>(initialStatisticsUrlState.startTime || new Date("2024-10-29 00:00:00"));
    const [endTime, setEndTime] = useState<any>(() => {
        if (initialStatisticsUrlState.endTime) {
            return initialStatisticsUrlState.endTime;
        }
        const d = new Date();
        d.setHours(23, 59, 59, 0);
        return d;
    });
    const [startFinishTime, setStartFinishTime] = useState<any>(initialStatisticsUrlState.startFinishTime || getDefaultStartTime());
    const [endFinishTime, setEndFinishTime] = useState<any>(initialStatisticsUrlState.endFinishTime || getDefaultEndTime());
    const [filterCampaignId, setFilterCampaignId] = useState<any>(initialStatisticsUrlState.filterCampaignId);
    const [filterNameTo, setFilterNameTo] = useState<any>(initialStatisticsUrlState.filterNameTo);
    const [filterANumber, setFilterANumber] = useState<any>(initialStatisticsUrlState.filterANumber);
    const [filterNameFrom, setFilterNameFrom] = useState<any>(initialStatisticsUrlState.filterNameFrom);
    const [filterAmdHangup, setFilterAmdHangup] = useState<any>(initialStatisticsUrlState.filterAmdHangup);
    const [filterCallReset, setFilterCallReset] = useState<any>(initialStatisticsUrlState.filterCallReset);
    const [filterStatus, setFilterStatus] = useState<any>(initialStatisticsUrlState.filterStatus);
    const [filterCampaignName, setFilterCampaignName] = useState<any>(initialStatisticsUrlState.filterCampaignName);
    const [filterBranchName, setFilterBranchName] = useState<any>(initialStatisticsUrlState.filterBranchName);
    const [filterQueueName, setFilterQueueName] = useState<any>(initialStatisticsUrlState.filterQueueName);
    const [filterFullName, setFilterFullName] = useState<any>(initialStatisticsUrlState.filterFullName);
    const [filterTypeChannel, setFilterTypeChannel] = useState<any>(initialStatisticsUrlState.filterTypeChannel);
    const [filterDirection, setFilterDirection] = useState<any>(initialStatisticsUrlState.filterDirection);
    const [filterDateTime, setFilterDateTime] = useState<any>(initialStatisticsUrlState.filterDateTime || new Date());
    const [filterEndDateTime, setFilterEndDateTime] = useState<any>(initialStatisticsUrlState.filterEndDateTime || new Date());
    const [filterFinishDateTime, setFilterFinishDateTime] = useState<any>(initialStatisticsUrlState.filterFinishDateTime || new Date());
    const [filterFinishEndDateTime, setFilterFinishEndDateTime] = useState<any>(initialStatisticsUrlState.filterFinishEndDateTime || getDefaultEndDate());
    const [isFinishDateFocused, setIsFinishDateFocused] = useState<boolean>(false);
    const [isFinishEndDateFocused, setIsFinishEndDateFocused] = useState<boolean>(false);
    const [isStartFinishTimeFocused, setIsStartFinishTimeFocused] = useState<boolean>(false);
    const [isEndFinishTimeFocused, setIsEndFinishTimeFocused] = useState<boolean>(false);
    const [fullCallDurationStartTime, setfullCallDurationStartTime] = useState<any>(initialStatisticsUrlState.fullCallDurationStartTime || getDefaultStartTime());
    const [fullCallDurationEndTime, setfullCallDurationEndTime] = useState<any>(initialStatisticsUrlState.fullCallDurationEndTime || getDefaultStartTime());
    const [durationStartTime, setDurationStartTime] = useState<any>(initialStatisticsUrlState.durationStartTime || getDefaultStartTime());
    const [durationEndTime, setDurationEndTime] = useState<any>(initialStatisticsUrlState.durationEndTime || getDefaultStartTime());
    const [reactionClientStartTime, setReactionClientStartTime] = useState<any>(initialStatisticsUrlState.reactionClientStartTime || getDefaultStartTime());
    const [reactionClientEndTime, setReactionClientEndTime] = useState<any>(initialStatisticsUrlState.reactionClientEndTime || getDefaultStartTime());
    const [reactionOperatorStartTime, setReactionOperatorStartTime] = useState<any>(initialStatisticsUrlState.reactionOperatorStartTime || getDefaultStartTime());
    const [reactionOperatorEndTime, setReactionOperatorEndTime] = useState<any>(initialStatisticsUrlState.reactionOperatorEndTime || getDefaultStartTime());
    const [visible, setVisible] = useState(false);
    const [filterOwnerType, setFilterOwnerType] = useState<any>(initialStatisticsUrlState.filterOwnerType);
    const [filterCallOwner, setFilterCallOwner] = useState<any>(initialStatisticsUrlState.filterCallOwner);
    const [activeTab, setActiveTab] = useState<string>('table1');
    const dataTableRef = useRef<DataTable | any>(null);
    // @ts-ignore
    const queuesDirectoryDirectionType = useAppSelector(state => state.QueueListReducer.queuesDirectoryDirectionType) as any;
    const [expandedRows, setExpandedRows] = useState<any>([]);
    const [expandedSessionRows, setExpandedSessionRows] = useState<any>([]);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [key, setKey] = useState(1);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const hasUsersAccess = !!rolesVision?.hasOwnProperty('Users');
    const hasBranchAccess = !!rolesVision?.hasOwnProperty('Branch');
    // @ts-ignore
    const usersData = useAppSelector(state => state.CompaniesListReducer.allSimpleUsers);
    const callTypeDictionary = useAppSelector(state => state.MonitoringListReducer.callTypeDictionary);
    const activeColumns = useMemo(() => {
        return [...(statisticSortFields?.fields || [])]
            .filter((item: { isActive: any }) => item.isActive)
            .sort((a: { order: number }, b: { order: number }) => a.order - b.order);
    }, [statisticSortFields]);
    const pageChanged = useAppSelector(state => state.StatisticsListReducer.pageChanged);
    const [fullCallDuration, setFullCallDuration] = useState<boolean>(initialStatisticsUrlState.fullCallDuration);
    const [duration, setDuration] = useState<boolean>(initialStatisticsUrlState.duration);
    const [reactionClient, setReactionClient] = useState<boolean>(initialStatisticsUrlState.reactionClient);
    const [reactionOperator, setReactionOperator] = useState<boolean>(initialStatisticsUrlState.reactionOperator);
    const [totalItems, setTotalItems] = useState<number>(paginationSize);
    const [hasStartFilter, setHasStartFilter] = useState<boolean>(initialStatisticsUrlState.hasStartFilter);
    const [hasEndFilter, setHasEndFilter] = useState<boolean>(initialStatisticsUrlState.hasEndFilter);
    const [appliedStartRange, setAppliedStartRange] = useState<{
        filterDateTime: Date | null;
        filterEndDateTime: Date | null;
        startTime: Date | null;
        endTime: Date | null;
    }>(() => ({
        filterDateTime: initialStatisticsUrlState.filterDateTime || new Date(),
        filterEndDateTime: initialStatisticsUrlState.filterEndDateTime || new Date(),
        startTime: initialStatisticsUrlState.startTime || new Date("2024-10-29 00:00:00"),
        endTime: initialStatisticsUrlState.endTime || (() => {
            const d = new Date();
            d.setHours(23, 59, 59, 0);
            return d;
        })(),
    }));
    const [hasStartFilterSnapshot, setHasStartFilterSnapshot] = useState(hasStartFilter);
    if (hasStartFilterSnapshot !== hasStartFilter) {
        setHasStartFilterSnapshot(hasStartFilter);
        setAppliedStartRange({
            filterDateTime,
            filterEndDateTime,
            startTime,
            endTime,
        });
    }
    const [updatedDataSort, setUpdatedDataSort] = useState<boolean>(false);
    const [allTimeChecked, setAllTimeChecked] = useState<boolean | null>(false);
    const [toggleButtonActivity, setToggleButtonActivity] = useState<any>(false);
    const [activity, setActivity] = useState<any>(false);
    const activityChangedManuallyRef2 = useRef(false);
    const prevDataSortRef = useRef<any>(null);
    const hasInitializedPagination = useRef(false);
    const skipUrlWriteRef = useRef(true);
    const skipDateResetFromUrlRef = useRef(initialStatisticsUrlState.hasStartFilter || initialStatisticsUrlState.hasEndFilter);
    const pendingUrlFilterSkipsRef = useRef(
        initialStatisticsUrlState.hasAny
            ? (Object.keys(initialStatisticsUrlState.uiFilters || {}).length > 0 ? 2 : 1)
            : 0
    );
    const prevHasStartFilterRef = useRef(hasStartFilter);
    const [filterApplyTick, setFilterApplyTick] = useState(0);

    function getDefaultEndTime(): Date {
        const d = new Date();
        d.setHours(23, 59, 59, 0);
        return d;
    }

    function getDefaultStartDate(): Date {
        return new Date("2023-06-01T00:00:00");
    }

    function getDefaultEndDate(): Date {
        return new Date();
    }
    const formatDate = (dateString: Date) => {
        const dateObj = new Date(dateString);

        const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
        const day = dateObj.getDate().toString().padStart(2, "0");
        const year = dateObj.getFullYear();

        return `${month}/${day}/${year}`;
    };

    const parseDateFromInputDigits = (digits: string): Date | null => {
        if (digits.length === 8) {
            const day = parseInt(digits.slice(0, 2), 10);
            const month = parseInt(digits.slice(2, 4), 10) - 1;
            const year = parseInt(digits.slice(4, 8), 10);
            const parsed = new Date(year, month, day);
            if (!isNaN(parsed.getTime()) && parsed.getDate() === day && parsed.getMonth() === month && parsed.getFullYear() === year) {
                return parsed;
            }
        }
        if (digits.length === 6) {
            const day = parseInt(digits.slice(0, 2), 10);
            const month = parseInt(digits.slice(2, 4), 10) - 1;
            const yy = parseInt(digits.slice(4, 6), 10);
            const year = yy + (yy >= 70 ? 1900 : 2000);
            const parsed = new Date(year, month, day);
            if (!isNaN(parsed.getTime()) && parsed.getDate() === day && parsed.getMonth() === month && parsed.getFullYear() === year) {
                return parsed;
            }
        }
        return null;
    };

    useEffect(() => {
        if (skipDateResetFromUrlRef.current) {
            skipDateResetFromUrlRef.current = false;
            return;
        }
        const minDate = new Date("2023-06-01T00:00:00");

        if (allTimeChecked !== null && allTimeChecked) {
            setStartTime(minDate);
            setEndTime(() => {
                const d = new Date();
                d.setHours(23, 59, 59, 0);
                return d;
            });
            setFilterDateTime(minDate);
            setFilterEndDateTime(getDefaultEndTime());
        } else {
            setStartTime(minDate);
            setEndTime(() => {
                const d = new Date();
                d.setHours(23, 59, 59, 0);
                return d;
            });
            setFilterDateTime(new Date()); // текущее
            setFilterEndDateTime(getDefaultEndTime());
        }
    }, [allTimeChecked]);

    useEffect(() => {
        if (initialStatisticsUrlState.hasAny) return;
        handleReset();
    }, [])

    useEffect(() => {
        return () => {
            dispatch(clearStatisticDashboard());
            dispatch(setStatisticsFilter(null));
        };
    }, [dispatch]);

    const formatDateTime = (dateString: any) => {
        const date = new Date(dateString);
        return `${date.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', second: '2-digit'})} ${date.toLocaleDateString('en-GB')}`;
    };

    const getTime = (dateString: Date | any, isEnd?: boolean) => {
        const dateObj = new Date(dateString);
        const hours = dateObj.getHours().toString().padStart(2, "0");
        const minutes = dateObj.getMinutes().toString().padStart(2, "0");

        return `${hours}:${minutes}:${isEnd ? `59` : `00`}`;
    };


    const [sortData, setSortData] = useState<any>({
        pageNumber: initialStatisticsUrlState.page,
        pageSize: initialStatisticsUrlState.size,
        sort: {
            orderBy: orderBy ? orderBy : "Id",
            isDesc: isDescFilter
        },
        username: user.userName
    });

    const resetTableHorizontalScroll = () => {
        const scrollableBody = document.querySelector('.p-datatable-wrapper');
        if (scrollableBody) {
            scrollableBody.scrollTop = 0; // Сброс прокрутки
            scrollableBody.scrollLeft = 0;
        }
    };

    useEffect(() => {
        if (!userStatisticSortFields?.userId && jwtToken?.jwtToken) {
            dispatch(getStatisticsUserSortFields(jwtToken.jwtToken));
        }
    }, [userStatisticSortFields?.userId, jwtToken?.jwtToken]);

    useEffect(() => {
        if (pagination.hasNext && pagination.pageNumber) {
            setTotalItems((pagination.pageNumber * paginationSize) + paginationSize)
        } else if (!pagination.hasNext && pagination.pageNumber) {
            setTotalItems(pagination.pageNumber * paginationSize);
        }
    }, [pagination, paginationSize]);


    useEffect(() => {
        setFirst(0);
    }, [pageChanged])

    const renderTableColumns = (caseFn: (name: string, i: number) => any) => {
        return activeColumns
            .map((col: { name: string }, i: number) => caseFn(col.name, i))
            .filter(Boolean);
    };

    const createUuidv4 = () => {
        return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
            // @ts-ignore
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    const formatItem = (item: { start: any; }) => {
        if (item && item.start) {
            return {
                ...item,
                start: formatDateTime(item.start),
                dateTime: createUuidv4()
            };
        }
        return item;
    };

    const formatDataRecursively = (obj: any) => {
        const formattedObj = {
            ...obj,
            item: formatItem(obj.item),
        };

        if (formattedObj.children && formattedObj.children.length > 0) {
            formattedObj.children = formattedObj.children.map((child: any) => formatDataRecursively(child));
        }

        return formattedObj;
    };

    const formattedData = statisticsList?.map(formatDataRecursively);

    useEffect(() => {
        handleResetPlayer();
    }, [selectedRowData]);

    const handleReset = () => {
        dataTableRef?.current?.reset();
        customFilter();
        setStartTime(new Date("2024-10-29 00:00:00"));
        setEndTime(() => {
            const d = new Date();
            d.setHours(23, 59, 59, 0);
            return d});
        setFilterEndDateTime(new Date());
        setStartFinishTime(getDefaultStartTime());
        setEndFinishTime(getDefaultEndTime());
        setFilterFinishDateTime(null);
        setFilterFinishEndDateTime(null);
        setSortOrder(0);
        setFirst(0);
        dispatch(setStatisticsCurrentPage(1));
        dispatch(setStatisticsCurrentPageSize(10));
        dispatch(resetAllStatisticFilters());
        setReactionClient(false);
        setReactionOperator(false);
        setFullCallDuration(false);
        setDuration(false);
        setReactionOperatorStartTime(getDefaultStartTime());
        setReactionOperatorEndTime(getDefaultStartTime());
        setReactionOperator(false);
        setDurationStartTime(getDefaultStartTime());
        setDurationEndTime(getDefaultStartTime());
        setfullCallDurationStartTime(getDefaultStartTime());
        setfullCallDurationEndTime(getDefaultStartTime());
        setReactionClientStartTime(getDefaultStartTime());
        setReactionClientEndTime(getDefaultStartTime());
        setReactionClient(false);
        setHasStartFilter(!hasStartFilter);
        setHasEndFilter(false);
        setFilterDateTime(new Date());
        setFilterEndDateTime(new Date());
        setAllTimeChecked(false);
        setActivity(false);
        setSortData({
            pageNumber: 1,
            pageSize: 10,
            sort: {
                orderBy: orderBy ? orderBy : "Id",
                isDesc: isDescFilter
            },
            username: user.userName
        });
        skipUrlWriteRef.current = true;
        setSearchParams(new URLSearchParams(), {replace: true});
        dispatch(clearStatisticDashboard());
        dispatch(setStatisticsFilter(null));
    };

    useEffect(() => {
        dispatch(getCampaignFilterList(jwtToken?.jwtToken));
        if (hasBranchAccess && jwtToken?.jwtToken) {
            dispatch(getUsersManagerUserBranchesData(jwtToken.jwtToken));
        }
    }, [dispatch, hasBranchAccess, jwtToken?.jwtToken]);

    useEffect(() => {
        if (!initialStatisticsUrlState.hasAny) return;
        if (Object.keys(initialStatisticsUrlState.uiFilters || {}).length > 0) {
            dispatch(setStatisticsUiFilters(initialStatisticsUrlState.uiFilters));
        }
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const onPageChange = (event: { first: React.SetStateAction<number>; page: number; rows: any; }) => {
        setFirst(event.first);
        dispatch(setStatisticsCurrentPage(event.page + 1));
        dispatch(setStatisticsCurrentPageSize(event.rows));
        setSortData((prev: any) => ({...prev, pageNumber: event.page + 1, pageSize: event.rows}));
    };

    // const getTimeWithoutSecond = (dateString: Date) => {
    //     const dateObj = new Date(dateString);
    //     const hours = dateObj.getHours().toString().padStart(2, "0");
    //     const minutes = dateObj.getMinutes().toString().padStart(2, "0");
    //
    //     return `${hours}:${minutes}`;
    // };


    useEffect(() => {
        if (!hasInitializedPagination.current) {
            hasInitializedPagination.current = true;
            const urlPage = initialStatisticsUrlState.page || 1;
            const urlSize = initialStatisticsUrlState.size || 10;
            const pageChanged = paginationPage !== urlPage;
            const sizeChanged = paginationSize !== urlSize;
            if (pageChanged) {
                dispatch(setStatisticsCurrentPage(urlPage));
            }
            if (sizeChanged) {
                dispatch(setStatisticsCurrentPageSize(urlSize));
            }
            if (pageChanged || sizeChanged) {
                return;
            }
        }
        let filter: {
            key: string;
            value: string
        }[] = [];

        const dataSort: any = {
            pageNumber: paginationPage,
            pageSize: paginationSize,
            sort: {
                orderBy: orderBy ? orderBy : "Id",
                isDesc: isDescFilter
            },
            username: user.userName
        }

        let rangeDateTime = appliedStartRange.filterDateTime;
        let rangeEndDateTime = appliedStartRange.filterEndDateTime;
        let rangeStartTime = appliedStartRange.startTime;
        let rangeEndTime = appliedStartRange.endTime;

        if (allTimeChecked) {
            const minDate = new Date("2023-06-01T00:00:00");
            const end = new Date();
            end.setHours(23, 59, 59, 0);
            rangeDateTime = minDate;
            rangeEndDateTime = new Date();
            rangeStartTime = minDate;
            rangeEndTime = end;
            setStartTime(minDate);
            setEndTime(end);
            setFilterDateTime(minDate);
            setFilterEndDateTime(rangeEndDateTime);
        }

        if (filterCampaignId?.value) {
            filter.push(filterCampaignId);
        }
        if (filterNameTo?.value) {
            filter.push(filterNameTo);
        }
        if (filterANumber?.value) {
            filter.push(filterANumber);
        }
        if (filterNameFrom?.value) {
            filter.push(filterNameFrom);
        }
        if (filterTypeChannel) {
            filterTypeChannel?.map((item: any) => {
                if (item.value === 'internalSkipped') {
                    filter.push({key: 'IsDeclined', value: '1'});
                } else {
                    filter.push(item);
                }
            })
        }

        if (filterCampaignName) {
            filterCampaignName?.map((item: any) => {
                filter.push(item);
            })
        }

        if (filterBranchName) {
            filterBranchName?.map((item: any) => {
                filter.push(item);
            })
        }

        if (filterCallOwner) {
            filterCallOwner?.map((item: any) => {
                filter.push(item);
            })
        }

        if (filterOwnerType) {
            filterOwnerType?.map((item: any) => {
                filter.push(item);
            })
        }

        if (filterQueueName) {
            filterQueueName?.map((item: any) => {
                filter.push(item);
            })
        }

        if (filterFullName) {
            filterFullName?.map((item: any) => {
                filter.push(item);
            })
        }

        if (filterStatus) {
            filterStatus.map((item: any) => {
                filter.push(item);
            })
        }
        if (filterDirection) {
            filterDirection.map((item: any) => {
                filter.push(item);
            })
        }
        if (filterAmdHangup) {
            filterAmdHangup.map((item: any) => {
                filter.push(item);
            })
        }
        if (filterCallReset) {
            filterCallReset.map((item: any) => {
                filter.push(item);
            })
        }


        let startAdded = false;
        let endAdded = false;

        if (rangeDateTime && rangeEndDateTime) {
            let startDate = formatDate(rangeDateTime);
            let endDate = formatDate(rangeEndDateTime);

            if (rangeStartTime && rangeEndTime) {
                let filterStartTime = getTime(rangeStartTime);
                let filterEndTime = getTime(rangeEndTime, true);
                filter.push({
                    "key": "Start",
                    "value": `${startDate} ${filterStartTime},${endDate} ${filterEndTime}`
                });
                startAdded = true;
            }
        }

        if (hasEndFilter) {
            let startDate = formatDate(filterFinishDateTime || new Date());
            let endDate = formatDate(filterFinishEndDateTime || getDefaultEndDate());
            let filterStartTime = getTime(startFinishTime || getDefaultStartTime());
            let filterEndTime = getTime(endFinishTime || getDefaultEndTime(), true);
            filter.push({
                "key": "End",
                "value": `${startDate} ${filterStartTime},${endDate} ${filterEndTime}`
            });
            endAdded = true;
        }

        if (!startAdded && !endAdded) {
            let currentDateTime = new Date();
            let currentDate = formatDate(currentDateTime);
            let currentTime = getTime(currentDateTime, true);
            filter.push({
                "key": "Start",
                "value": `${currentDate} 00:00:00,${currentDate} ${currentTime}`
            });
        }

        const addFilterSecond = (condition: boolean, key: string, startTime: number, endTime: number) => {
            if (
                condition &&
                startTime !== undefined && startTime !== null &&
                endTime !== undefined && endTime !== null
            ) {
                filter.push({
                    "key": key,
                    "value": `${startTime}, ${endTime}`
                });
            }
        }

        const isDefaultTime = (time: Date | null | false): boolean => {
            if (!time) return true;
            const defaultTime = getDefaultStartTime();
            return time.getTime() === defaultTime.getTime();
        };

        const getTotalSeconds = (date: any) => {
            if (!date) return null;
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const seconds = date.getSeconds();
            return hours * 3600 + minutes * 60 + seconds;
        };


        if (reactionClientStartTime && reactionClientEndTime &&
            (!isDefaultTime(reactionClientStartTime) || !isDefaultTime(reactionClientEndTime))) {
            addFilterSecond(reactionClient, "ReactionClient", getTotalSeconds(reactionClientStartTime), getTotalSeconds(reactionClientEndTime));
        }
        if (reactionOperatorStartTime && reactionOperatorEndTime &&
            (!isDefaultTime(reactionOperatorStartTime) || !isDefaultTime(reactionOperatorEndTime))) {
            addFilterSecond(reactionOperator, "ReactionOperator", getTotalSeconds(reactionOperatorStartTime), getTotalSeconds(reactionOperatorEndTime));
        }
        if (fullCallDurationStartTime && fullCallDurationEndTime &&
            (!isDefaultTime(fullCallDurationStartTime) || !isDefaultTime(fullCallDurationEndTime))) {
            addFilterSecond(fullCallDuration, "FullCallDuration", getTotalSeconds(fullCallDurationStartTime), getTotalSeconds(fullCallDurationEndTime));
        }
        if (durationStartTime && durationEndTime &&
            (!isDefaultTime(durationStartTime) || !isDefaultTime(durationEndTime))) {
            addFilterSecond(duration, "Duration", getTotalSeconds(durationStartTime), getTotalSeconds(durationEndTime));
        }

        if (filter) {
            dataSort['filter'] = filter;
        }

        const prevDataSort = prevDataSortRef.current;
        const hasChanged = JSON.stringify(prevDataSort) !== JSON.stringify(dataSort);

        const hasStartFilterChanged = prevHasStartFilterRef.current !== hasStartFilter;
        prevHasStartFilterRef.current = hasStartFilter;

        if (prevDataSort && !hasChanged && !hasStartFilterChanged) return;

        if (hasStartFilterChanged && paginationPage !== 1) {
            dataSort.pageNumber = 1;
            setFirst(0);
            dispatch(setStatisticsCurrentPage(1));
        }

        prevDataSortRef.current = dataSort;

        const startEntry = dataSort?.filter?.length
            ? dataSort.filter.find((item: { key: string; }) => item.key === "Start")
            : undefined;
        const endEntry = dataSort?.filter?.length
            ? dataSort.filter.find((item: { key: string; }) => item.key === "End")
            : undefined;
        if (allTimeChecked !== null && (startEntry || endEntry)) {
            collapseAll();
            dispatch(getStatisticsWithPaginationFilterAndSorting(dataSort, jwtToken?.jwtToken));
            dispatch(setStatisticsFilter(dataSort));
            dispatch(getStatisticDashboard(dataSort.filter || [], jwtToken?.jwtToken));
            setSortData(dataSort);
            resetTableHorizontalScroll();
        } else {
            dispatch({type: GET_STATISTICS, payload: null});
            dispatch(clearStatisticDashboard());
            dispatch(setStatisticsFilter(null));
        }

    }, [paginationPage, paginationSize, orderBy, isDescFilter, sortOrder, filterCampaignId, filterNameTo, filterANumber, filterNameFrom, filterTypeChannel, filterStatus, filterCampaignName, filterBranchName, filterQueueName, filterCallOwner, filterOwnerType, filterFullName, filterDirection, filterAmdHangup, filterCallReset, reactionClient, reactionOperator, duration, fullCallDuration, hasStartFilter, hasEndFilter, filterApplyTick, appliedStartRange]);

    useEffect(() => {
        if (skipUrlWriteRef.current) {
            skipUrlWriteRef.current = false;
            return;
        }

        const nextParams = buildStatisticsSearchParams({
            page: paginationPage,
            size: paginationSize,
            orderBy,
            isDesc: isDescFilter,
            sortOrder,
            filterCampaignId,
            filterNameTo,
            filterANumber,
            filterNameFrom,
            filterTypeChannel,
            filterOwnerType,
            filterFullName,
            filterCampaignName,
            filterBranchName,
            filterCallOwner,
            filterQueueName,
            filterDirection,
            filterStatus,
            filterAmdHangup,
            filterCallReset,
            filterDateTime: appliedStartRange.filterDateTime,
            filterEndDateTime: appliedStartRange.filterEndDateTime,
            startTime: appliedStartRange.startTime,
            endTime: appliedStartRange.endTime,
            hasStartFilter,
            filterFinishDateTime,
            filterFinishEndDateTime,
            startFinishTime,
            endFinishTime,
            hasEndFilter,
            duration,
            durationStartTime,
            durationEndTime,
            fullCallDuration,
            fullCallDurationStartTime,
            fullCallDurationEndTime,
            reactionClient,
            reactionClientStartTime,
            reactionClientEndTime,
            reactionOperator,
            reactionOperatorStartTime,
            reactionOperatorEndTime,
        });

        if (!areSearchParamsEqual(searchParams, nextParams)) {
            setSearchParams(nextParams, {replace: true});
        }
    }, [
        paginationPage, paginationSize, orderBy, isDescFilter, sortOrder,
        filterCampaignId, filterNameTo, filterANumber, filterNameFrom,
        filterTypeChannel, filterOwnerType, filterFullName, filterCampaignName,
        filterBranchName, filterCallOwner, filterQueueName, filterDirection,
        filterStatus, filterAmdHangup, filterCallReset,
        appliedStartRange, hasStartFilter,
        filterFinishDateTime, filterFinishEndDateTime, startFinishTime, endFinishTime, hasEndFilter,
        duration, durationStartTime, durationEndTime,
        fullCallDuration, fullCallDurationStartTime, fullCallDurationEndTime,
        reactionClient, reactionClientStartTime, reactionClientEndTime,
        reactionOperator, reactionOperatorStartTime, reactionOperatorEndTime,
        searchParams, setSearchParams
    ]);

    useEffect(() => {
        if (activeClick?.item === "/statistics" && getHashPath(activeClick?.from) === '#/statistics') {
            dispatch(getStatisticsWithPaginationFilterAndSorting(sortData, jwtToken?.jwtToken));
            dispatch(getStatisticDashboard(sortData?.filter || [], jwtToken?.jwtToken));
            resetTableHorizontalScroll();
        }
    }, [activeClick]);

    const monitoringSort = (event: { sortField: any; }) => {
        const handleAction = (sortField: string) => {
            let newOrderBy: string;

            switch (sortField) {
                case 'item.userName':
                    newOrderBy = 'UserName';
                    break;
                case 'item.typeChannel':
                    newOrderBy = 'TypeChannel';
                    break;
                case 'item.start':
                    newOrderBy = 'Start';
                    break;
                case 'item.callType':
                    newOrderBy = 'CallType';
                    break;
                case 'item.ownerUserName':
                    newOrderBy = 'OwnerUserName';
                    break;
                case 'OwnerType':
                    newOrderBy = 'OwnerType';
                    break;
                case 'item.status':
                    newOrderBy = 'Status';
                    break;
                case 'item.ani':
                    newOrderBy = 'Ani';
                    break;
                case 'item.aNumber':
                    newOrderBy = 'ANumber';
                    break;
                case 'item.campaignName':
                    newOrderBy = 'CampaignName';
                    break;
                case 'item.campaignId':
                    newOrderBy = 'CampaignId';
                    break;
                case 'item.branchId':
                    newOrderBy = 'BranchId';
                    break;
                case 'item.callReset':
                    newOrderBy = 'CallReset';
                    break;
                case 'forcedClosing':
                    newOrderBy = 'ForcedClosing';
                    break;
                case 'item.fullName':
                    newOrderBy = 'UserName';
                    break;
                case 'item.direction':
                    newOrderBy = 'Direction';
                    break;
                case 'item.queueId':
                    newOrderBy = 'QueueId';
                    break;
                case 'item.ownerCall':
                    newOrderBy = 'OwnerCall';
                    break;
                case 'FullCallDuration':
                    newOrderBy = 'FullCallDuration';
                    break;
                case 'Duration':
                    newOrderBy = 'Duration';
                    break;
                case 'ReactionOperator':
                    newOrderBy = 'ReactionOperator';
                    break;
                case 'ReactionClient':
                    newOrderBy = 'ReactionClient';
                    break;
                case 'End':
                    newOrderBy = 'End';
                    break;
                default:
                    return;
            }

            setOrderBy(newOrderBy);
            setIsDescFilter(!isDescFilter);
            setSortOrder(sortOrder === 1 ? -1 : 1);
            dispatch(setStatisticsCurrentPage(1));
            setFirst(0);
        };
        let sortField = event.sortField;
        handleAction(sortField);
    };

    const filterClearTemplate = (options: { filterClearCallback: React.MouseEventHandler<HTMLButtonElement> | undefined; field: string }) => {
        return <Button type="button" className="p-button-secondary" icon="pi pi-times" onClick={(e) => {
            if (options.filterClearCallback) {
                options.filterClearCallback(e);
            }
            if (options.field === 'start') {
                const clearedEndTime = new Date();
                clearedEndTime.setHours(23, 59, 59, 0);
                setStartTime(null);
                setEndTime(clearedEndTime);
                setFilterDateTime(null);
                setFilterEndDateTime(null);
                setAppliedStartRange({
                    filterDateTime: null,
                    filterEndDateTime: null,
                    startTime: null,
                    endTime: clearedEndTime,
                });
            }
            if (options.field === 'end') {
                setStartFinishTime(null);
                setEndFinishTime(null);
                setFilterFinishDateTime(null);
                setFilterFinishEndDateTime(null);
                setHasEndFilter(false);
            }
            if (options.field === 'reactionClient') {
                setReactionClientStartTime(null);
                setReactionClientEndTime(null);
                setReactionClient(false);
            }
            if (options.field === 'reactionOperator') {
                setReactionOperatorStartTime(null);
                setReactionOperatorEndTime(null);
                setReactionOperator(false);
            }
            if (options.field === 'duration') {
                setDuration(false);
                setDurationStartTime(null);
                setDurationEndTime(null);
            }
            if (options.field === 'fullCallDuration') {
                setfullCallDurationStartTime(null);
                setfullCallDurationEndTime(null);
                setFullCallDuration(false);
            }
        }}></Button>;
    }

    const filterApplyTemplate = (options: {
        filterApplyCallback: React.MouseEventHandler<HTMLButtonElement> | undefined;
        field: string;
    }) => {
        const handleClick = () => {
            if (options.field === 'start') {
                const nextStartRange = {
                    filterDateTime: filterDateTime || new Date(),
                    filterEndDateTime: filterEndDateTime || new Date(),
                    startTime: startTime || getDefaultStartTime(),
                    endTime: endTime || getDefaultEndTime(),
                };
                if (!filterDateTime) setFilterDateTime(nextStartRange.filterDateTime);
                if (!filterEndDateTime) setFilterEndDateTime(nextStartRange.filterEndDateTime);
                if (!startTime) setStartTime(nextStartRange.startTime);
                if (!endTime) setEndTime(nextStartRange.endTime);
                setAppliedStartRange(nextStartRange);
                setHasStartFilter(true);

                if (dataTableRef.current) {
                    const filterValue = startTime || getDefaultStartTime();
                    dataTableRef.current.filter(filterValue, 'start', 'contains');
                }
            }

            if (options.field === 'end') {
                if (!startFinishTime) setStartFinishTime(getDefaultStartTime());
                if (!endFinishTime) setEndFinishTime(getDefaultEndTime());

                setHasEndFilter(true);

                // Применяем фильтр программно через ref
                if (dataTableRef.current) {
                    const filterValue = endFinishTime || getDefaultEndTime();
                    dataTableRef.current.filter(filterValue, 'end', 'contains');
                }
            }

            if (options.field === 'reactionClient') {
                if (!reactionClientStartTime) setReactionClientStartTime(getDefaultStartTime());
                setReactionClient(true);

                // Применяем фильтр программно через ref
                if (dataTableRef.current) {
                    const filterValue = reactionClientStartTime || getDefaultStartTime();
                    dataTableRef.current.filter(filterValue, 'reactionClient', 'contains');
                }
            }

            if (options.field === 'reactionOperator') {
                if (!reactionOperatorStartTime) setReactionOperatorStartTime(getDefaultStartTime());
                setReactionOperator(true);

                // Применяем фильтр программно через ref
                if (dataTableRef.current) {
                    const filterValue = reactionOperatorStartTime || getDefaultStartTime();
                    dataTableRef.current.filter(filterValue, 'reactionOperator', 'contains');
                }
            }

            if (options.field === 'fullCallDuration') {
                if (!fullCallDurationStartTime) setfullCallDurationStartTime(getDefaultStartTime());
                setFullCallDuration(true);

                // Применяем фильтр программно через ref
                if (dataTableRef.current) {
                    const filterValue = fullCallDurationStartTime || getDefaultStartTime();
                    dataTableRef.current.filter(filterValue, 'fullCallDuration', 'contains');
                }
            }

            if (options.field === 'duration') {
                if (!durationStartTime) setDurationStartTime(getDefaultStartTime());
                setDuration(true);

                // Применяем фильтр программно через ref
                if (dataTableRef.current) {
                    const filterValue = durationStartTime || getDefaultStartTime();
                    dataTableRef.current.filter(filterValue, 'duration', 'contains');
                }
            }

            const commitsLocalRange = options.field === 'start'
                || options.field === 'end'
                || options.field === 'reactionClient'
                || options.field === 'reactionOperator'
                || options.field === 'fullCallDuration'
                || options.field === 'duration';
            if (commitsLocalRange) {
                setFilterApplyTick((tick) => tick + 1);
            }
            if (options.filterApplyCallback) {
                options.filterApplyCallback({} as any);
            }
        };

        const isTimeValid = (startTime: Date | null | false, endTime: Date | null | false): boolean => {
            if (!startTime || !endTime) return true;
            return endTime.getTime() > startTime.getTime();
        };

        return <Button type="button" icon="pi pi-check" onClick={handleClick} className=""
                       disabled={
                           (options.field === 'duration' && (!durationEndTime || !isTimeValid(durationStartTime, durationEndTime))) ||
                           (options.field === 'fullCallDuration' && (!fullCallDurationEndTime || !isTimeValid(fullCallDurationStartTime, fullCallDurationEndTime))) ||
                           (options.field === 'reactionOperator' && (!reactionOperatorEndTime || !isTimeValid(reactionOperatorStartTime, reactionOperatorEndTime))) ||
                           (options.field === 'reactionClient' && (!reactionClientEndTime || !isTimeValid(reactionClientStartTime, reactionClientEndTime))) ||
                           (options.field === 'start' && ((!filterDateTime || !filterEndDateTime) || !isTimeValid(startTime, endTime)))
                           }></Button>
    }

    useEffect(() => {
        if (hasUsersAccess) {
            dispatch(getAllSimpleUsers(jwtToken?.jwtToken));
        }
    }, [hasUsersAccess, jwtToken?.jwtToken]);

    const customFilter = (event?: any) => {
        if (event) {
            const filters = event.filters || {};

            setFirst(0);
            dispatch(setStatisticsCurrentPage(1));
            const setFilter = (filterName: string, key: string, defaultValue?: any | null) => {
                if (!filters[filterName]) {
                    return defaultValue;
                }

                const value = filters[filterName].value || filters[filterName].constraints?.[0]?.value;
                if (!value) {
                    return defaultValue;
                }

                if (Array?.isArray(value)) {
                    return value.map((item) => ({key, value: String(item)}));
                } else {
                    return {key, value: String(value)};
                }
            };

            setFilterCampaignId(setFilter('campaignId', 'CampaignId'));
            setFilterNameTo(() => {
                const ani = filters['ani']?.value || filters['ani']?.constraints?.[0]?.value;
                if (!ani) return null;

                const cleanedValue = ani.replace(/[()\-\s\n\t\r+,;!'"?:$%&/]/g, '');
                return { key: 'ANI', value: cleanedValue };
            });
            setFilterANumber(setFilter('aNumber', 'ANumber'));
            setFilterNameFrom(setFilter('userName', 'UserName'));
            setFilterTypeChannel(setFilter('callType', 'CallType', []));
            setFilterOwnerType(setFilter('ownerType', 'OwnerType', []));
            setFilterFullName(setFilter('fullName', 'UserName', []));
            setFilterCampaignName(setFilter('campaignFullName', 'CampaignId', []));
            setFilterBranchName(setFilter('branchId', 'BranchId', []));
            setFilterCallOwner(setFilter('ownerUserName', 'OwnerUserName', []));
            setFilterQueueName(setFilter('queueFullName', 'QueueId', []));
            setFilterDirection(setFilter('direction', 'Direction', []));
            setFilterStatus(setFilter('status', 'Status', []));
            setFilterAmdHangup(setFilter('forcedClosing', 'ForcedClosing', []));
            setFilterCallReset(setFilter('callResetName', 'CallReset', []));
            setAppliedStartRange({
                filterDateTime,
                filterEndDateTime,
                startTime,
                endTime,
            });
        } else {
            setFilterCampaignId(null);
            setFilterFullName(null);
            setFilterNameTo(null);
            setFilterNameFrom(null);
            setFilterStatus(null);
            setFilterOwnerType(null);
            setFilterCampaignName(null);
            setFilterBranchName(null);
            setFilterTypeChannel(null);
            setFilterAmdHangup(null);
            setFilterCallReset(null);
            setOrderBy(null);
            setIsDescFilter(true);
            setFilterDirection(null);
            setFilterQueueName(null);
            setFilterCallOwner(null);
            setFilterANumber(null);
            setActivity(false);
        }
    };

    const renderHeader = (field: string, sortField: string) => {
        const sorted = sortField === orderBy;
        const sortIcon = classNames('p-sortable-column-icon', {
            'pi pi-sort-amount-up-alt': sorted && sortOrder === 1,
            'pi pi-fw pi-sort-amount-down': sorted && sortOrder === -1,
            'pi pi-fw pi-sort-alt': sortOrder === 0 || !sorted
        });

        return (
            <div className="flex align-items-center" onClick={() => monitoringSort({'sortField': sortField})}>
                {field} <i className={sortIcon}></i>
            </div>
        );
    };

    const toggleTab = (tableName: string) => {
        setSelectedRowData(null);
        setActiveTab(tableName);
    };

    const isMobile = () => {
        return windowWidth <= 1248;
    }

    const renderActivityColumn = ({item}: any) => {
        return item?.callType === 'transferInternal' && !item.isDeclined ? (
            <div className="relative">
                <i className="pi pi-reply p-2 bg-green-500 border-circle text-white"
                   style={{transform: 'rotate(90deg) scaleX(1) scaleY(-1)'}}></i>
            </div>
        ) : item?.callType === 'transferInternal' && item.isDeclined ? (
                <div className="relative">
                    <i className="pi pi-reply p-2 bg-green-500 border-circle text-white"
                       style={{transform: 'rotate(90deg) scaleX(1) scaleY(-1)'}}></i>
                    <div className="absolute" style={{top: '-5px', left: '18px'}}>
                        <div className="border-circle relative"
                             style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                            <i className="pi pi-times text-white absolute left-50 top-50 kk"
                               style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                        </div>
                    </div>
                </div>) :

            item?.callType === 'transferExternal' && !item.isDeclined ? (
                <div className="relative">
                    <i className="pi pi-reply p-2 bg-primary border-circle text-white"
                       style={{transform: 'rotate(90deg) scaleX(-1) scaleY(-1)'}}></i>
                </div>
            ) : item?.callType === 'callbackExternal' && !item.isDeclined ? (
                <div className="relative">
                    <i className="pi pi-undo p-2 border-circle text-white"
                       style={{background: 'rgb(253, 166, 16)'}}></i>
                    <div className="absolute" style={{top: '-5px', left: '18px'}}>
                        <div className="border-circle relative bg-primary"
                             style={{width: '14px', height: '14px'}}>
                            <i className="pi pi-arrow-up-right text-white absolute left-50 top-50 kk"
                               style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                        </div>
                    </div>
                </div>) : item?.callType === 'callbackInternal' && !item.isDeclined ? (
                <div className="relative">
                    <i className="pi pi-undo p-2 border-circle text-white"
                       style={{background: 'rgb(253, 166, 16)'}}></i>
                    <div className="absolute" style={{top: '-5px', left: '18px'}}>
                        <div className="border-circle relative bg-green-500"
                             style={{width: '14px', height: '14px'}}>
                            <i className="pi pi-arrow-down-left text-white absolute left-50 top-50 kk"
                               style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                        </div>
                    </div>
                </div>) : (item?.callType === 'callbackInternal' || item?.callType === 'callbackExternal') && item.isDeclined ? (
                <div className="relative">
                    <i className="pi pi-undo p-2 border-circle text-white"
                       style={{background: 'rgb(253, 166, 16)'}}></i>
                    <div className="absolute" style={{top: '-5px', left: '18px'}}>
                        <div className="border-circle relative"
                             style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                            <i className="pi pi-times text-white absolute left-50 top-50 kk"
                               style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                        </div>
                    </div>
                </div>): item?.callType === 'transferInternal' && item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-reply p-2 bg-primary border-circle text-white"
                           style={{transform: 'rotate(90deg) scaleX(-1) scaleY(-1)'}}></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>)
                : item?.callType === 'callback' ? (
                    <div className="relative">
                        <i className="pi pi-undo p-2 border-circle text-white" style={{backgroundColor: "#fda610"}}></i>
                    </div>
                ) : item?.callType === 'internal' && !item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-arrow-down-left p-2 border-circle bg-green-500 text-white"></i>
                    </div>
                ) : item?.callType === 'internal' && item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-arrow-down-left p-2 border-circle bg-green-500 text-white"></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>) : item?.callType === 'external' && !item.isDeclined ? (
                    <>
                        <i className="pi pi-arrow-up-right bg-primary p-2 border-circle text-white"></i>
                    </>
                ) : item?.callType === 'ivm' && !item.isDeclined ? (
                    <>
                        <i className="bg-primary p-2 border-circle text-white font-bold relative"
                           style={{fontStyle: "normal", width: '27.99px', height: '27.99px'}}><span
                            className="absolute"
                            style={{left: '50%', top: '50%', transform: 'translate(-50%, -50%)', fontSize: '11px'}}>IVM</span></i>
                    </>
                ) : item?.callType === 'ivm' && item.isDeclined ? (
                    <div className="relative inline-block">
                        <i className="bg-primary border-circle text-white font-bold relative inline-flex align-items-center justify-content-center"
                           style={{fontStyle: "normal", width: '28px', height: '28px', minWidth: '28px', minHeight: '28px', borderRadius: '50%'}}><span
                            style={{fontSize: '11px'}}>IVM</span></i>
                        <div className="absolute" style={{top: '-3px', right: '-3px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>
                ) : item?.callType === 'ivr' && !item.isDeclined ? (
                    <>
                        <i className="bg-green-500 p-2 border-circle text-white font-bold relative"
                           style={{fontStyle: "normal", width: '27.99px', height: '27.99px'}}><span
                            className="absolute"
                            style={{left: '50%', top: '50%', transform: 'translate(-50%, -50%)', fontSize: '11px'}}>IVR</span></i>
                    </>
                ) : item?.callType === 'ivr' && item.isDeclined ? (
                    <div className="relative inline-block">
                        <i className="bg-green-500 border-circle text-white font-bold relative inline-flex align-items-center justify-content-center"
                           style={{fontStyle: "normal", width: '28px', height: '28px', minWidth: '28px', minHeight: '28px', borderRadius: '50%'}}><span
                            style={{fontSize: '11px'}}>IVR</span></i>
                        <div className="absolute" style={{top: '-3px', right: '-3px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>
                ) : item?.callType === 'external' && item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-arrow-up-right bg-primary p-2 border-circle text-white"></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>) : item?.callType === 'consultation' && !item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-users p-2 border-circle text-white" style={{background: 'rgb(253, 166, 16)'}}></i>
                    </div>
                ) : item?.callType === 'consultation' && item.isDeclined ? (
                        <div className="relative">
                            <i className="pi pi-users p-2 border-circle text-white"
                               style={{background: 'rgb(253, 166, 16)'}}></i>
                            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                <div className="border-circle relative"
                                     style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                    <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                </div>
                            </div>
                        </div>)


                    : item?.callType === 'consultationExternal' && !item.isDeclined ? (
                        <div className="relative">
                            <i className="pi pi-users p-2 border-circle text-white"
                               style={{background: 'rgb(253, 166, 16)'}}></i>
                            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                <div className="border-circle relative bg-primary"
                                     style={{width: '14px', height: '14px'}}>
                                    <i className="pi pi-arrow-up-right text-white absolute left-50 top-50 kk"
                                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                </div>
                            </div>
                        </div>
                    ) : item?.callType === 'consultationInternal' && !item.isDeclined ? (
                        <div className="relative">
                            <i className="pi pi-users p-2 border-circle text-white"
                               style={{background: 'rgb(253, 166, 16)'}}></i>
                            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                <div className="border-circle relative bg-green-500"
                                     style={{width: '14px', height: '14px'}}>
                                    <i className="pi pi-arrow-down-left text-white absolute left-50 top-50 kk"
                                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                </div>
                            </div>
                        </div>
                    ) : (item?.callType === 'consultationInternal' || item?.callType === 'consultationExternal') && item.isDeclined ? (
                        <div className="relative">
                            <i className="pi pi-users p-2 border-circle text-white"
                               style={{background: 'rgb(253, 166, 16)'}}></i>
                            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                <div className="border-circle relative"
                                     style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                    <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                </div>
                            </div>
                        </div>) : (item?.callType === 'pickupcall') && item.isDeclined ? (
                        <div className="relative">
                            <i className="pi pi-user p-2 border-circle text-white"
                               style={{background: 'rgb(253, 166, 16)'}}></i>
                            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                <div className="border-circle relative"
                                     style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                    <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                </div>
                            </div>
                        </div>) : item?.callType === 'pickupcall' && !item.isDeclined ? (
                        <div className="relative">
                            <i className="pi pi-user p-2 border-circle text-white" style={{background: 'rgb(253, 166, 16)'}}></i>
                        </div>) : (item?.callType === 'spycall') && item.isDeclined ? (
                        <div className="relative">
                            <i className="pi pi-headphones p-2 border-circle text-white"
                               style={{background: 'rgb(253, 166, 16)'}}></i>
                            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                <div className="border-circle relative"
                                     style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                    <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                </div>
                            </div>
                        </div>) : item?.callType === 'spycall' && !item.isDeclined ? (
                        <div className="relative">
                            <i className="pi pi-headphones p-2 border-circle text-white" style={{background: 'rgb(253, 166, 16)'}}></i>
                        </div>) : <></>;
    };

    const handleResetPlayer = () => {
        dispatch({type: UPLOAD_AUDIO_LOADING, payload: false});
        dispatch(setAudioUnavailable(false));
        dispatch(getAudioUrlForPlayer(null));
        setKey(key + 1);
    };

    const typeBodyTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {rowData.item?.ownerUserName}
                </span>
            </React.Fragment>
        );
    };

    const contactNameBodyTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <span style={{verticalAlign: 'middle'}} className="image-text">
                    {rowData.item?.pathSegment ?
                        <a target="_blank" className="mb-2" href={`${rowData.item?.pathSegment}?sessionId=${rowData.item?.sessionId}`}>{rowData.item?.contactName}</a> :
                        <p className="m-0 mb-2">{rowData.item?.contactName}</p>}
                    {/*{rowData.item?.contactName || '- - -'}*/}
                </span>
            </React.Fragment>
        );
    };

    const ownerTypeFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть тип</div>
                <MultiSelect
                    filter
                    value={options.value}
                    options={ownerTypeDictionary}
                    optionLabel="description"
                    optionValue="dictionaryId"
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter mb-3"
                />
            </>
        );
    };

    const typeOperatorTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {rowData.item?.fullName}
                </span>
            </React.Fragment>
        );
    };


    const typeDirectionBodyTemplate = (rowData: DataRow) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {rowData.item?.direction}
                </span>
            </React.Fragment>
        );
    };

    const campaignBodyTemplate = (rowData: DataRow) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {rowData.item?.campaignFullName}
                </span>
            </React.Fragment>
        );
    };

    const queueBodyTemplate = (rowData: DataRow) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {rowData.item?.queueFullName}
                </span>
            </React.Fragment>
        );
    };

    const branchBodyTemplate = (rowData: DataRow) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {formatBranchDisplayLabel(rowData.item, branches)}
                </span>
            </React.Fragment>
        );
    };

    const callResetBodyTemplate = (rowData: any) => {
        const foundCallReset = callResetDictionary?.filter((item: any) => item?.dictionaryId === rowData?.item?.callReset);
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {foundCallReset?.[0]?.name}
                </span>
            </React.Fragment>
        );
    };

    const amdHangupBodyTemplate = (rowData: any) => {
        const foundAmdHangup = forcedClosingDictionary?.filter((item: any) => item?.dictionaryId === rowData?.item?.forcedClosing);
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {foundAmdHangup?.[0]?.name}
                </span>
            </React.Fragment>
        );
    };

    const renderStatusColumn = (rowData: any) => {
        let foundStatus = statusDictionary?.filter((status: any) => status?.dictionaryId === rowData?.item?.status);

        const statusMap: {
            [key: string]: string
        } = {
            101: 'p-badge status-active',
            103: 'p-badge status-success',
            104: 'p-badge status-unsuccessful',
            ACTION: 'p-badge status-action',
            102: 'p-badge status-processing'
        };

        const statusClass = statusMap[foundStatus?.[0]?.dictionaryId];

        return (
            <Badge value={foundStatus?.[0]?.name} className={`${statusClass} text-white customer-badge w-6 text-xs p-0`}
                   style={{maxWidth: '95px', minWidth: '95px'}}/>
        );
    };

    const amdHangupFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Виберіть:</div>
                <MultiSelect
                    filter
                    value={options.value}
                    options={forcedClosingDictionary}
                    optionLabel='name'
                    optionValue={'dictionaryId'}
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"
                />
            </>
        );
    };
    const callResetFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Виберіть ініціатора</div>
                <MultiSelect
                    filter
                    value={options.value}
                    options={callResetDictionary || null}
                    optionValue="dictionaryId"
                    optionLabel="name"
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"
                />
            </>
        );
    };

    const statusFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть статус</div>
                <MultiSelect
                    filter
                    value={options.value}
                    options={statusDictionary || null}
                    optionValue="dictionaryId"
                    optionLabel="name"
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"
                />
            </>
        );
    };

    const directionFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть статус</div>
                <MultiSelect
                    filter
                    value={options.value}
                    optionValue="name"
                    options={queuesDirectoryDirectionType}
                    optionLabel="name"
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"
                />
            </>
        );
    };
    const usersDataWithFullName = usersData?.map((userData: any) => {
        return {
            ...userData,
            fullName: `${userData?.lastName} ${userData?.firstName} ${userData?.middleName ? `${userData.middleName}` : ''}`
        }
    });

    const campaignListWithId = campaignList?.campaigns?.map((campaignData: any) => {
        return {
            ...campaignData,
            campaignWithId: `${campaignData.id} ${campaignData.name}`
        }
    });

    const queueListWithId = campaignList?.queues?.map((queueData: any) => {
        return {
            ...queueData,
            queueWithId: `${queueData?.id} ${queueData?.name}`
        }
    });

    const formattedBranches = branches?.map((branch: { id: any; name: any; }) => ({
        ...branch,
        label: `${branch.id} ${branch.name}`,
    }));

    const operatorItemTemplate = (item: any) => {
        return <div className="flex justify-content-between"><div>{item.fullName}</div> <div className="ml-3 text-sm">{!item?.isActive && 'Архівний'}</div></div>;
    }

    const operatorFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть:</div>
                <MultiSelect
                    value={options.value}
                    optionValue="userName"
                    selectedItemsLabel={options.value ? `Обрано: ${options.value.length}` : ""}
                    filter
                    options={usersDataWithFullName}
                    itemClassName="w-full operatorItem"
                    maxSelectedLabels={0}
                    itemTemplate={operatorItemTemplate}
                    optionLabel="fullName"
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"

                />
            </>
        );
    };
    const ownerFilterTemplate = (options: any) => {
        let usersData: any
        if (!Array.isArray(usersDataWithFullName)) {
            console.error('usersDataWithFullName is not an array');
        } else {
            usersData = [
                {value: "", userName: ""},
                ...usersDataWithFullName
            ];
        }
        return (
            <>
                <div className="mb-3 text-bold">Оберіть:</div>
                <MultiSelect
                    value={options.value}
                    optionValue="userName"
                    selectedItemsLabel={options.value ? `Обрано: ${options.value.length}` : ""}
                    filter
                    options={usersData}
                    maxSelectedLabels={0}
                    optionLabel="userName"
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"

                />
            </>
        );
    };

    const campaignFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть:</div>
                <MultiSelect
                    value={options.value}
                    optionValue="id"
                    selectedItemsLabel={options.value ? `Обрано: ${options.value.length}` : ""}
                    filter
                    options={campaignListWithId}
                    maxSelectedLabels={0}
                    optionLabel="campaignWithId"
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"

                />
            </>
        );
    };

    const branchFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть:</div>
                <MultiSelect
                    filter
                    value={options.value}
                    options={formattedBranches}
                    optionLabel="label"
                    optionValue="id"
                    selectedItemsLabel={options?.value?.length ? `Обрано: ${options.value.length}` : "0"}
                    maxSelectedLabels={0}
                    onChange={(e: any) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"
                />
            </>
        );
    };

    const queueFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть:</div>
                <MultiSelect
                    value={options.value}
                    optionValue="id"
                    selectedItemsLabel={options.value ? `Обрано: ${options.value.length}` : ""}
                    filter
                    options={queueListWithId}
                    maxSelectedLabels={0}
                    optionLabel="queueWithId"
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"

                />
            </>
        );
    };

    const typeChannelItemTemplate = (option: any) => {
        let statusName = callTypeDictionary?.map((item: any) => {
            if (item.name === option) {
                return item.description
            }
        })
        return (
            <div className="p-multiselect-representative-option">
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {statusName}
                </span>
            </div>
        );
    }

    const selectedTypeChannelTemplate = (option: any) => {
        let statusName = callTypeDictionary?.map((item: any) => {
            if (item.name === option) {
                return item.description
            }
        })
        if (option) {
            return (
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {statusName},
                </span>
            );
        }

        return "Оберіть тип";
    }

    function getDefaultStartTime(): Date {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        return d;
    }


    const dateFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <>
            <span className="title">Виберіть дату</span>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>З*</span>
                <Calendar className="mt-2" value={filterDateTime ? filterDateTime : null} onChange={(e: any) => {
                    options.filterCallback(e.value, options.index);
                    setFilterDateTime(e.value)
                }} onInput={(e: any) => {
                    const input = e.target as HTMLInputElement;

                    const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                    const dd = digits.slice(0, 2);
                    const mm = digits.slice(2, 4);
                    const yyyy = digits.slice(4, 8);

                    const display =
                        (dd || "") +
                        (digits.length > 2 ? "/" + mm : "") +
                        (digits.length > 4 ? "/" + yyyy : "");

                    const newCaret =
                        digits.length +
                        (digits.length > 2 ? 1 : 0) +
                        (digits.length > 4 ? 1 : 0);

                    if (input.value !== display) {
                        input.value = display;
                        input.setSelectionRange(newCaret, newCaret);
                    }

                    if (digits.length === 8) {
                        const day = parseInt(dd, 10);
                        const month = parseInt(mm, 10) - 1; // 0-based
                        const year = parseInt(yyyy, 10);
                        const parsed = new Date(year, month, day);

                        const valid =
                            !isNaN(parsed.getTime()) &&
                            parsed.getDate() === day &&
                            parsed.getMonth() === month &&
                            parsed.getFullYear() === year;

                        setFilterDateTime(valid ? parsed : null);
                    }
                }} onFocus={(e: any) => {
                    if (filterDateTime) {
                        setFilterDateTime(null);
                    }
                }} onBlur={(e: any) => {
                    const digits = e.target.value.replace(/\D/g, "");
                    if (digits.length !== 8) {
                        e.target.value = "";
                        setFilterDateTime(null);
                    }
                }} minDate={new Date(2023, 5, 1)} // 01.06.2023
                maxDate={new Date()}
                dateFormat="dd/mm/yy" placeholder="дд/мм/рр"/>
            </div>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>По*</span>
                <Calendar className="mt-2" value={filterEndDateTime ? filterEndDateTime : null} onChange={(e: any) => {
                    setFilterEndDateTime(e.value)
                }} onInput={(e: any) => {
                    const input = e.target as HTMLInputElement;

                    const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                    const dd = digits.slice(0, 2);
                    const mm = digits.slice(2, 4);
                    const yyyy = digits.slice(4, 8);

                    const display =
                        (dd || "") +
                        (digits.length > 2 ? "/" + mm : "") +
                        (digits.length > 4 ? "/" + yyyy : "");

                    const newCaret =
                        digits.length +
                        (digits.length > 2 ? 1 : 0) +
                        (digits.length > 4 ? 1 : 0);

                    if (input.value !== display) {
                        input.value = display;
                        input.setSelectionRange(newCaret, newCaret);
                    }

                    if (digits.length === 8) {
                        const day = parseInt(dd, 10);
                        const month = parseInt(mm, 10) - 1; // 0-based
                        const year = parseInt(yyyy, 10);
                        const parsed = new Date(year, month, day);

                        const valid =
                            !isNaN(parsed.getTime()) &&
                            parsed.getDate() === day &&
                            parsed.getMonth() === month &&
                            parsed.getFullYear() === year;

                        setFilterEndDateTime(valid ? parsed : null);
                    }
                }} onFocus={(e: any) => {
                    if (filterEndDateTime) {
                        setFilterEndDateTime(null);
                    }
                }} onBlur={(e: any) => {
                    const digits = e.target.value.replace(/\D/g, "");
                    if (digits.length !== 8) {
                        e.target.value = "";
                        setFilterEndDateTime(null);
                    }
                }} minDate={new Date(2023, 5, 1)} // 01.06.2023
                maxDate={new Date()}
                dateFormat="dd/mm/yy" placeholder="дд/мм/рр"/>
            </div>
            <div className="flex max-w-15rem">
                <div className="md:col-6">
                    <div className="time-item">
                        <span className="title">З*</span>
                        <Calendar
                            appendTo="self"
                            id="icon"
                            placeholder="00:00"
                            value={startTime || getDefaultStartTime()}
                            timeOnly
                            hourFormat="24"
                            onChange={(e) => setStartTime(e.value)}
                            onFocus={() => {
                                setStartTime(null);
                            }}
                            onBlur={() => {
                                if (!startTime) {
                                    const defaultTime = getDefaultStartTime();
                                    if (defaultTime) {
                                        setStartTime(defaultTime);
                                    }
                                }
                            }}
                            onInput={(e: any) => {
                                const input = e.target as HTMLInputElement;

                                let digits = input.value.replace(/\D/g, "").slice(0, 4);
                                const HH = digits.slice(0, 2);
                                const MM = digits.slice(2, 4);

                                const display = HH + (digits.length > 2 ? ":" + MM : "");

                                if (input.value !== display) {
                                    const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                    input.value = display;
                                    input.setSelectionRange(caret, caret);
                                }

                                if (digits.length === 4) {
                                    const h = parseInt(HH, 10);
                                    const m = parseInt(MM, 10);
                                    const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                    if (valid) {
                                        const base = startTime ? new Date(startTime) : new Date();
                                        base.setHours(h, m, 0, 0);
                                        setStartTime(base);
                                    }
                                }
                            }}
                        />
                    </div>
                </div>
                <div className="md:col-6">
                    <div className="time-item">
                        <span className="title">По*</span>
                        <Calendar
                            appendTo="self"
                            id="icon"
                            placeholder="00:00"
                            value={endTime || getDefaultEndTime()}
                            timeOnly
                            hourFormat="24"
                            onChange={(e) => setEndTime(e.value)}
                            onFocus={() => {
                                setEndTime(null);
                            }}
                            onBlur={() => {
                                if (!endTime) {
                                    const defaultTime = getDefaultEndTime();
                                    if (defaultTime) {
                                        setEndTime(defaultTime);
                                    }
                                }
                            }}
                            onInput={(e: any) => {
                                const input = e.target as HTMLInputElement;

                                let digits = input.value.replace(/\D/g, "").slice(0, 4);
                                const HH = digits.slice(0, 2);
                                const MM = digits.slice(2, 4);

                                const display = HH + (digits.length > 2 ? ":" + MM : "");

                                if (input.value !== display) {
                                    const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                    input.value = display;
                                    input.setSelectionRange(caret, caret);
                                }

                                if (digits.length === 4) {
                                    const h = parseInt(HH, 10);
                                    const m = parseInt(MM, 10);
                                    const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                    if (valid) {
                                        const base = endTime ? new Date(endTime) : new Date();
                                        base.setHours(h, m, 0, 0);
                                        setEndTime(base);
                                    }
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    };

    const dateEndFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <>
            <span className="title">Виберіть дату</span>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>З*</span>
                <Calendar className="mt-2" value={isFinishDateFocused ? null : (filterFinishDateTime || new Date())}
                          onChange={(e: any) => {
                              // options.filterCallback(e.value, options.index);
                              setFilterFinishDateTime(e.value)
                          }} onInput={(e: any) => {
                              const input = e.target as HTMLInputElement;

                              const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                              const dd = digits.slice(0, 2);
                              const mm = digits.slice(2, 4);
                              const yyyy = digits.slice(4, 8);

                              const display =
                                  (dd || "") +
                                  (digits.length > 2 ? "/" + mm : "") +
                                  (digits.length > 4 ? "/" + yyyy : "");

                              const newCaret =
                                  digits.length +
                                  (digits.length > 2 ? 1 : 0) +
                                  (digits.length > 4 ? 1 : 0);

                              if (input.value !== display) {
                                  input.value = display;
                                  input.setSelectionRange(newCaret, newCaret);
                              }

                              if (digits.length === 8) {
                                  const day = parseInt(dd, 10);
                                  const month = parseInt(mm, 10) - 1; // 0-based
                                  const year = parseInt(yyyy, 10);
                                  const parsed = new Date(year, month, day);

                                  const valid =
                                      !isNaN(parsed.getTime()) &&
                                      parsed.getDate() === day &&
                                      parsed.getMonth() === month &&
                                      parsed.getFullYear() === year;

                                  setFilterFinishDateTime(valid ? parsed : null);
                              }
                          }} onFocus={(e: any) => {
                              setIsFinishDateFocused(true);
                          }} onBlur={(e: any) => {
                              setIsFinishDateFocused(false);
                              const digits = e.target.value.replace(/\D/g, "");
                              const parsed = parseDateFromInputDigits(digits);
                              if (parsed) {
                                  setFilterFinishDateTime(parsed);
                              } else if (!filterFinishDateTime) {
                                  e.target.value = "";
                                  setFilterFinishDateTime(new Date());
                              }
                          }} minDate={new Date(2023, 5, 1)} // 01.06.2023
                          maxDate={new Date()}
                          dateFormat="dd/mm/yy" placeholder="дд/мм/рр"/>
            </div>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>По*</span>
                <Calendar className="mt-2" value={isFinishEndDateFocused ? null : (filterFinishEndDateTime || getDefaultEndDate())}
                          onChange={(e: any) => {
                              setFilterFinishEndDateTime(e.value)
                          }} onInput={(e: any) => {
                              const input = e.target as HTMLInputElement;

                              const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                              const dd = digits.slice(0, 2);
                              const mm = digits.slice(2, 4);
                              const yyyy = digits.slice(4, 8);

                              const display =
                                  (dd || "") +
                                  (digits.length > 2 ? "/" + mm : "") +
                                  (digits.length > 4 ? "/" + yyyy : "");

                              const newCaret =
                                  digits.length +
                                  (digits.length > 2 ? 1 : 0) +
                                  (digits.length > 4 ? 1 : 0);

                              if (input.value !== display) {
                                  input.value = display;
                                  input.setSelectionRange(newCaret, newCaret);
                              }

                              if (digits.length === 8) {
                                  const day = parseInt(dd, 10);
                                  const month = parseInt(mm, 10) - 1; // 0-based
                                  const year = parseInt(yyyy, 10);
                                  const parsed = new Date(year, month, day);

                                  const valid =
                                      !isNaN(parsed.getTime()) &&
                                      parsed.getDate() === day &&
                                      parsed.getMonth() === month &&
                                      parsed.getFullYear() === year;

                                  setFilterFinishEndDateTime(valid ? parsed : null);
                              }
                          }} onFocus={(e: any) => {
                              setIsFinishEndDateFocused(true);
                          }} onBlur={(e: any) => {
                              setIsFinishEndDateFocused(false);
                              const digits = e.target.value.replace(/\D/g, "");
                              const parsed = parseDateFromInputDigits(digits);
                              if (parsed) {
                                  setFilterFinishEndDateTime(parsed);
                              } else if (!filterFinishEndDateTime) {
                                  e.target.value = "";
                                  setFilterFinishEndDateTime(getDefaultEndDate());
                              }
                          }} minDate={new Date(2023, 5, 1)} // 01.06.2023
                          maxDate={new Date()}
                          dateFormat="dd/mm/yy" placeholder="дд/мм/рр"/>
            </div>
            <div className="flex max-w-15rem">
                <div className="md:col-6">
                    <div className="time-item">
                        <span className="title">З*</span>
                        <Calendar
                            appendTo="self"
                            id="icon"
                            placeholder="00:00"
                            value={isStartFinishTimeFocused ? null : (startFinishTime || getDefaultStartTime())}
                            timeOnly
                            hourFormat="24"
                            onChange={(e) => setStartFinishTime(e.value)}
                            onFocus={() => {
                                setIsStartFinishTimeFocused(true);
                            }}
                            onBlur={() => {
                                setIsStartFinishTimeFocused(false);
                                if (!startFinishTime) {
                                    const defaultTime = getDefaultStartTime();
                                    if (defaultTime) {
                                        setStartFinishTime(defaultTime);
                                    }
                                }
                            }}
                            onInput={(e: any) => {
                                const input = e.target as HTMLInputElement;

                                let digits = input.value.replace(/\D/g, "").slice(0, 4);
                                const HH = digits.slice(0, 2);
                                const MM = digits.slice(2, 4);

                                const display = HH + (digits.length > 2 ? ":" + MM : "");

                                if (input.value !== display) {
                                    const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                    input.value = display;
                                    input.setSelectionRange(caret, caret);
                                }

                                if (digits.length === 4) {
                                    const h = parseInt(HH, 10);
                                    const m = parseInt(MM, 10);
                                    const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                    if (valid) {
                                        const base = startFinishTime ? new Date(startFinishTime) : new Date();
                                        base.setHours(h, m, 0, 0);
                                        setStartFinishTime(base);
                                    }
                                }
                            }}
                        />
                    </div>
                </div>
                <div className="md:col-6">
                    <div className="time-item">
                        <span className="title">По*</span>
                        <Calendar
                            appendTo="self"
                            id="icon"
                            placeholder="00:00"
                            value={isEndFinishTimeFocused ? null : (endFinishTime || getDefaultEndTime())}
                            timeOnly
                            hourFormat="24"
                            onChange={(e) => setEndFinishTime(e.value)}
                            onFocus={() => {
                                setIsEndFinishTimeFocused(true);
                            }}
                            onBlur={() => {
                                setIsEndFinishTimeFocused(false);
                                if (!endFinishTime) {
                                    const defaultTime = getDefaultEndTime();
                                    if (defaultTime) {
                                        setEndFinishTime(defaultTime);
                                    }
                                }
                            }}
                            onInput={(e: any) => {
                                const input = e.target as HTMLInputElement;

                                let digits = input.value.replace(/\D/g, "").slice(0, 4);
                                const HH = digits.slice(0, 2);
                                const MM = digits.slice(2, 4);

                                const display = HH + (digits.length > 2 ? ":" + MM : "");

                                if (input.value !== display) {
                                    const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                    input.value = display;
                                    input.setSelectionRange(caret, caret);
                                }

                                if (digits.length === 4) {
                                    const h = parseInt(HH, 10);
                                    const m = parseInt(MM, 10);
                                    const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                    if (valid) {
                                        const base = endFinishTime ? new Date(endFinishTime) : new Date();
                                        base.setHours(h, m, 0, 0);
                                        setEndFinishTime(base);
                                    }
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    };

    const fullCallDurationFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <>
            <span className="title">Виберіть час:</span>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>З*</span>
                <Calendar
                    timeOnly
                    showSeconds
                    hourFormat="24"
                    className="mt-2"
                    placeholder="00:00:00"
                    value={fullCallDurationStartTime || null}
                    onChange={(e: any) => {
                        if (e.value) setfullCallDurationStartTime(e.value);
                    }}
                    onFocus={() => {
                        setfullCallDurationStartTime(null);
                    }}
                    onBlur={() => {
                        if (!fullCallDurationStartTime) {
                            const defaultTime = getDefaultStartTime();
                            if (defaultTime) {
                                setfullCallDurationStartTime(defaultTime);
                            }
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 6);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);
                        const SS = digits.slice(4, 6);

                        const display =
                            HH +
                            (digits.length > 2 ? ":" + MM : "") +
                            (digits.length > 4 ? ":" + SS : "");

                        if (input.value !== display) {
                            const caret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 6) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const s = parseInt(SS, 10);
                            const valid =
                                h >= 0 && h <= 23 &&
                                m >= 0 && m <= 59 &&
                                s >= 0 && s <= 59;

                            if (valid) {
                                const base =
                                    fullCallDurationStartTime
                                        ? new Date(fullCallDurationStartTime)
                                        : (getDefaultStartTime() ? new Date(getDefaultStartTime()) : new Date());
                                base.setHours(h, m, s, 0);
                                setfullCallDurationStartTime(base);
                            }
                        }
                    }}
                />
            </div>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>По*</span>
                <Calendar
                    timeOnly
                    showSeconds
                    hourFormat="24"
                    className="mt-2"
                    placeholder="00:00:00"
                    value={fullCallDurationEndTime || null}
                    onChange={(e: any) => {
                        if (e.value) setfullCallDurationEndTime(e.value);
                    }}
                    onFocus={() => {
                        setfullCallDurationEndTime(null);
                    }}
                    onBlur={() => {
                        if (!fullCallDurationEndTime) {
                            const defaultTime = getDefaultStartTime();
                            if (defaultTime) {
                                setfullCallDurationEndTime(defaultTime);
                            }
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 6);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);
                        const SS = digits.slice(4, 6);

                        const display =
                            HH +
                            (digits.length > 2 ? ":" + MM : "") +
                            (digits.length > 4 ? ":" + SS : "");

                        if (input.value !== display) {
                            const caret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 6) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const s = parseInt(SS, 10);
                            const valid =
                                h >= 0 && h <= 23 &&
                                m >= 0 && m <= 59 &&
                                s >= 0 && s <= 59;

                            if (valid) {
                                const base =
                                    fullCallDurationEndTime
                                        ? new Date(fullCallDurationEndTime)
                                        : (getDefaultStartTime() ? new Date(getDefaultStartTime()) : new Date());
                                base.setHours(h, m, s, 0);
                                setfullCallDurationEndTime(base);
                            }
                        }
                    }}
                />
            </div>
        </>
    };

    const durationFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <>
            <span className="title">Виберіть час:</span>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>З*</span>
                <Calendar
                    timeOnly
                    showSeconds
                    hourFormat="24"
                    className="mt-2"
                    placeholder="00:00:00"
                    value={durationStartTime || null}
                    onChange={(e: any) => {
                        if (e.value) setDurationStartTime(e.value);
                    }}
                    onFocus={() => {
                        setDurationStartTime(null);
                    }}
                    onBlur={() => {
                        if (!durationStartTime) {
                            const defaultTime = getDefaultStartTime();
                            if (defaultTime) {
                                setDurationStartTime(defaultTime);
                            }
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 6);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);
                        const SS = digits.slice(4, 6);

                        const display =
                            HH +
                            (digits.length > 2 ? ":" + MM : "") +
                            (digits.length > 4 ? ":" + SS : "");

                        if (input.value !== display) {
                            const caret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 6) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const s = parseInt(SS, 10);
                            const valid =
                                h >= 0 && h <= 23 &&
                                m >= 0 && m <= 59 &&
                                s >= 0 && s <= 59;

                            if (valid) {
                                const base =
                                    durationStartTime
                                        ? new Date(durationStartTime)
                                        : (getDefaultStartTime() ? new Date(getDefaultStartTime()) : new Date());
                                base.setHours(h, m, s, 0);
                                setDurationStartTime(base);
                            }
                        }
                    }}
                />
            </div>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>По*</span>
                <Calendar
                    timeOnly
                    showSeconds
                    hourFormat="24"
                    className="mt-2"
                    placeholder="00:00:00"
                    value={durationEndTime || null}
                    onChange={(e: any) => {
                        if (e.value) setDurationEndTime(e.value);
                    }}
                    onFocus={() => {
                        setDurationEndTime(null);
                    }}
                    onBlur={() => {
                        if (!durationEndTime) {
                            const defaultTime = getDefaultStartTime();
                            if (defaultTime) {
                                setDurationEndTime(defaultTime);
                            }
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 6);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);
                        const SS = digits.slice(4, 6);

                        const display =
                            HH +
                            (digits.length > 2 ? ":" + MM : "") +
                            (digits.length > 4 ? ":" + SS : "");

                        if (input.value !== display) {
                            const caret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 6) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const s = parseInt(SS, 10);
                            const valid =
                                h >= 0 && h <= 23 &&
                                m >= 0 && m <= 59 &&
                                s >= 0 && s <= 59;

                            if (valid) {
                                const base =
                                    durationEndTime
                                        ? new Date(durationEndTime)
                                        : (getDefaultStartTime() ? new Date(getDefaultStartTime()) : new Date());
                                base.setHours(h, m, s, 0);
                                setDurationEndTime(base);
                            }
                        }
                    }}
                />
            </div>
        </>
    };

    const reactionClientFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <>
            <span className="title">Виберіть час:</span>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>З*</span>
                <Calendar
                    timeOnly
                    showSeconds
                    hourFormat="24"
                    className="mt-2"
                    placeholder="00:00:00"
                    value={reactionClientStartTime || null}
                    onChange={(e: any) => {
                        if (e.value) setReactionClientStartTime(e.value);
                    }}
                    onFocus={() => {
                        setReactionClientStartTime(null);
                    }}
                    onBlur={() => {
                        if (!reactionClientStartTime) {
                            const defaultTime = getDefaultStartTime();
                            if (defaultTime) {
                                setReactionClientStartTime(defaultTime);
                            }
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 6);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);
                        const SS = digits.slice(4, 6);

                        const display =
                            HH +
                            (digits.length > 2 ? ":" + MM : "") +
                            (digits.length > 4 ? ":" + SS : "");

                        if (input.value !== display) {
                            const caret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 6) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const s = parseInt(SS, 10);
                            const valid =
                                h >= 0 && h <= 23 &&
                                m >= 0 && m <= 59 &&
                                s >= 0 && s <= 59;

                            if (valid) {
                                const base =
                                    reactionClientStartTime
                                        ? new Date(reactionClientStartTime)
                                        : (getDefaultStartTime() ? new Date(getDefaultStartTime()) : new Date());
                                base.setHours(h, m, s, 0);
                                setReactionClientStartTime(base);
                            }
                        }
                    }}
                />
            </div>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>По*</span>
                <Calendar
                    timeOnly
                    showSeconds
                    hourFormat="24"
                    className="mt-2"
                    placeholder="00:00:00"
                    value={reactionClientEndTime || null}
                    onChange={(e: any) => {
                        if (e.value) setReactionClientEndTime(e.value);
                    }}
                    onFocus={() => {
                        setReactionClientEndTime(null);
                    }}
                    onBlur={() => {
                        if (!reactionClientEndTime) {
                            const defaultTime = getDefaultStartTime();
                            if (defaultTime) {
                                setReactionClientEndTime(defaultTime);
                            }
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 6);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);
                        const SS = digits.slice(4, 6);

                        const display =
                            HH +
                            (digits.length > 2 ? ":" + MM : "") +
                            (digits.length > 4 ? ":" + SS : "");

                        if (input.value !== display) {
                            const caret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 6) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const s = parseInt(SS, 10);
                            const valid =
                                h >= 0 && h <= 23 &&
                                m >= 0 && m <= 59 &&
                                s >= 0 && s <= 59;

                            if (valid) {
                                const base =
                                    reactionClientEndTime
                                        ? new Date(reactionClientEndTime)
                                        : (getDefaultStartTime() ? new Date(getDefaultStartTime()) : new Date());
                                base.setHours(h, m, s, 0);
                                setReactionClientEndTime(base);
                            }
                        }
                    }}
                />
            </div>
        </>
    };

    const reactionOperatorFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <>
            <span className="title">Виберіть час:</span>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>З*</span>
                <Calendar
                    timeOnly
                    showSeconds
                    hourFormat="24"
                    className="mt-2"
                    placeholder="00:00:00"
                    value={reactionOperatorStartTime || null}
                    onChange={(e: any) => {
                        if (e.value) setReactionOperatorStartTime(e.value);
                    }}
                    onFocus={() => {
                        setReactionOperatorStartTime(null);
                    }}
                    onBlur={() => {
                        if (!reactionOperatorStartTime) {
                            const defaultTime = getDefaultStartTime();
                            if (defaultTime) {
                                setReactionOperatorStartTime(defaultTime);
                            }
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 6);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);
                        const SS = digits.slice(4, 6);

                        const display =
                            HH +
                            (digits.length > 2 ? ":" + MM : "") +
                            (digits.length > 4 ? ":" + SS : "");

                        if (input.value !== display) {
                            const caret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 6) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const s = parseInt(SS, 10);
                            const valid =
                                h >= 0 && h <= 23 &&
                                m >= 0 && m <= 59 &&
                                s >= 0 && s <= 59;

                            if (valid) {
                                const base =
                                    reactionOperatorStartTime
                                        ? new Date(reactionOperatorStartTime)
                                        : (getDefaultStartTime() ? new Date(getDefaultStartTime()) : new Date());
                                base.setHours(h, m, s, 0);
                                setReactionOperatorStartTime(base);
                            }
                        }
                    }}
                />
            </div>
            <div className="flex field align-items-center max-w-15rem">
                <span className="title" style={{width: '35px'}}>По*</span>
                <Calendar
                    timeOnly
                    showSeconds
                    hourFormat="24"
                    className="mt-2"
                    placeholder="00:00:00"
                    value={reactionOperatorEndTime || null}
                    onChange={(e: any) => {
                        if (e.value) setReactionOperatorEndTime(e.value);
                    }}
                    onFocus={() => {
                        setReactionOperatorEndTime(null);
                    }}
                    onBlur={() => {
                        if (!reactionOperatorEndTime) {
                            const defaultTime = getDefaultStartTime();
                            if (defaultTime) {
                                setReactionOperatorEndTime(defaultTime);
                            }
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 6);
                        const HH = digits.slice(0, 2);
                        const MM = digits.slice(2, 4);
                        const SS = digits.slice(4, 6);

                        const display =
                            HH +
                            (digits.length > 2 ? ":" + MM : "") +
                            (digits.length > 4 ? ":" + SS : "");

                        if (input.value !== display) {
                            const caret =
                                digits.length +
                                (digits.length > 2 ? 1 : 0) +
                                (digits.length > 4 ? 1 : 0);
                            input.value = display;
                            input.setSelectionRange(caret, caret);
                        }

                        if (digits.length === 6) {
                            const h = parseInt(HH, 10);
                            const m = parseInt(MM, 10);
                            const s = parseInt(SS, 10);
                            const valid =
                                h >= 0 && h <= 23 &&
                                m >= 0 && m <= 59 &&
                                s >= 0 && s <= 59;

                            if (valid) {
                                const base =
                                    reactionOperatorEndTime
                                        ? new Date(reactionOperatorEndTime)
                                        : (getDefaultStartTime() ? new Date(getDefaultStartTime()) : new Date());
                                base.setHours(h, m, s, 0);
                                setReactionOperatorEndTime(base);
                            }
                        }
                    }}
                />
            </div>
        </>
    };

    const typeChannelFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть тип</div>
                <MultiSelect
                    filter
                    value={options.value}
                    options={callTypeDictionary?.map((item: any) => item.name)}
                    itemTemplate={typeChannelItemTemplate}
                    selectedItemTemplate={selectedTypeChannelTemplate}
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter mb-3"
                />
            </>
        );
    };

    const updateFilter = (field: string, value: any) => {
        dispatch(updateStatisticFilter(field, value));
    };

    useEffect(() => {
        if (activityChangedManuallyRef2.current) {
            activityChangedManuallyRef2.current = false;

            if (activity) {
                updateFilter('fullName', [`${user?.userName}`]);
            } else {
                updateFilter('fullName', null);
            }
        }
    }, [activity, user?.userName]);

    useEffect(() => {
        if (!filterFullName || filterFullName.length !== 1) {
            if (activity) {
                setActivity(false);
            }
            return;
        }

        const onlyItem = filterFullName[0];

        if (onlyItem.value === user?.userName) {
            if (!activity) {
                setActivity(true);
            }
        } else {
            if (activity) {
                setActivity(false);
            }
        }
    }, [filterFullName, user?.userName]);



    useEffect(() => {
        if (clearFilters) {
            if (pendingUrlFilterSkipsRef.current > 0) {
                pendingUrlFilterSkipsRef.current -= 1;
                return;
            }
            customFilter({ filters: clearFilters });
        }
    }, [clearFilters]);

    const BSessionIcon = () => {
        return <i className="pi pi-reply mr-2" style={{fontSize: '1rem', transform: 'rotate(270deg)'}}></i>
    }

    // const convertMillisecondsToTime = (totalMilliseconds: number): string => {
    //     const hours = Math.floor(totalMilliseconds / (1000 * 60 * 60));
    //     const minutes = Math.floor((totalMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
    //     const seconds = Math.floor((totalMilliseconds % (1000 * 60)) / 1000);
    //
    //     return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    // };

    const convertSecondsToTime = (totalSeconds: number): string => {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = Math.floor(totalSeconds % 60);

        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const aniFilterTemplate = (options: any) => {
        return<InputText placeholder="Введіть назву клiента" className="mt-2" value={options.value || ''}
                         onChange={(e: any) => {
                             const cleaned = e.target.value?.replace(/[()\-\s\n\t\r+,;!'"?:$%&/]/g, '');
                             options.filterCallback(cleaned, options.index);
                         }}/>
    };

    const firstLevelTableCase = (name: string, i: number) => {
        let itemName: any;

        switch (name) {
            case "ani":
                itemName = <Column
                    key={i}
                    field="item.ani"
                    filterField="ani"
                    filterElement={aniFilterTemplate}
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть назву клiента"
                    filter
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterMenuClassName={'filterStart'}
                    bodyClassName={(rowData) => rowData.item?.isMatchingSessionId ? 'your-custom-class' : ''}
                    header={'Клiент'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "aNumber":
                itemName = <Column
                    key={i}
                    field="item.aNumber"
                    filterField="aNumber"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть транк"
                    filter
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterMenuClassName={'filterStart'}
                    bodyClassName={(rowData) => rowData.item?.isMatchingSessionId ? 'your-custom-class' : ''}
                    header={'Транк'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '150px'}}
                />;
                break;
            case "ownerUserName":
                itemName = <Column
                    key={i}
                    field="item.ownerUserName"
                    filterField="ownerUserName"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть назву власника"
                    filter={hasUsersAccess}
                    filterElement={hasUsersAccess ? ownerFilterTemplate : undefined}
                    filterClear={hasUsersAccess ? filterClearTemplate : undefined}
                    filterApply={hasUsersAccess ? filterApplyTemplate : undefined}
                    header={'Власник дзвінка'}
                    body={typeBodyTemplate}
                    filterMenuClassName={'filterStart'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "fullName":
                itemName = <Column
                    field="item.fullName"
                    key={i}
                    sortable
                    filterField="fullName"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть назву оператора"
                    filter={hasUsersAccess}
                    filterElement={hasUsersAccess ? operatorFilterTemplate : undefined}
                    filterClear={hasUsersAccess ? filterClearTemplate : undefined}
                    filterApply={hasUsersAccess ? filterApplyTemplate : undefined}
                    header={renderHeader('Оператор', 'Username')}
                    body={typeOperatorTemplate}
                    filterMenuClassName={'filterStart'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "direction":
                itemName = <Column
                    field="item.direction"
                    key={i}
                    filterField="direction"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть назву оператора"
                    filter
                    filterElement={directionFilterTemplate}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    header={'Тип Активності'}
                    body={typeDirectionBodyTemplate}
                    filterMenuClassName={'filterStart'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "campaignFullName":
                itemName = <Column
                    field="item.campaignId"
                    sortable
                    key={i}
                    filterField="campaignFullName"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть назву кампанії"
                    filter
                    body={campaignBodyTemplate}
                    filterElement={campaignFilterTemplate}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterMenuClassName={'filterStart'}
                    header={renderHeader('ID / Назва Кампанii', 'CampaignId')}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "branchId":
                itemName = <Column
                    field="item.branchId"
                    sortable
                    key={i}
                    filterField="branchId"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть branch"
                    filter={hasBranchAccess}
                    body={branchBodyTemplate}
                    filterElement={hasBranchAccess ? branchFilterTemplate : undefined}
                    filterClear={hasBranchAccess ? filterClearTemplate : undefined}
                    filterApply={hasBranchAccess ? filterApplyTemplate : undefined}
                    filterMenuClassName={'filterStart'}
                    header={renderHeader('ID / Branch', 'BranchId')}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "queueFullName":
                itemName = <Column
                    field="item.queueId"
                    sortable
                    key={i}
                    filterField="queueFullName"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть назву черги"
                    filter
                    body={queueBodyTemplate}
                    filterElement={queueFilterTemplate}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterMenuClassName={'filterStart'}
                    header={renderHeader('ID / Назва Черги', 'QueueId')}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "status":
                itemName = <Column
                    field="item.status"
                    header={renderHeader('Статус', 'Status')}
                    sortable
                    key={i}
                    filterField="status"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterElement={statusFilterTemplate}
                    filter
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterMenuClassName={'filterStart'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '150px'}}
                    body={renderStatusColumn}
                />;
                break;
            case "callType":
                itemName = <Column
                    field="item.callType"
                    header={'Активність'}
                    key={i}
                    filterField="callType"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть ID кампанії"
                    filter
                    filterElement={typeChannelFilterTemplate}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    body={renderActivityColumn}
                    filterMenuClassName={'filterStart'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '150px'}}
                />;
                break;
            case "callResetName":
                itemName = <Column
                    field="item.callReset"
                    sortable
                    filterField="callResetName"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filter
                    key={i}
                    filterElement={callResetFilterTemplate}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    header={renderHeader('Завершив', 'CallReset')}
                    body={callResetBodyTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '160px'}}
                    filterMenuClassName={'filterStart'}
                />;
                break;
            case "forcedClosing":
                itemName = <Column
                    field="forcedClosing"
                    header={renderHeader('Причина завершення', 'ForcedClosing')}
                    sortable
                    key={i}
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterElement={amdHangupFilterTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '180px'}}
                    body={amdHangupBodyTemplate}
                    filterMenuClassName={'filterStart'}
                    filter
                    filterField="forcedClosing"
                />;
                break;
            case "start":
                itemName = <Column
                    field="item.start"
                    filterField="start"
                    key={i}
                    filterElement={dateFilterTemplate}
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть ID кампанії"
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterMenuClassName={'filterStart'}
                    header={renderHeader('Початок', 'Start')}
                    sortable
                    style={{cursor: 'pointer', width: `100%`, minWidth: '170px'}}
                />;
                break;
            case "fullCallDuration":
                itemName = <Column
                    key={i}
                    header={renderHeader('Тривалість дзвінка', 'FullCallDuration')}
                    className="justify-content-start"
                    body={(data) => data.item.fullCallDuration && data?.item?.fullCallDuration !== -1 ? convertSecondsToTime(data?.item.fullCallDuration) : data?.item?.fullCallDuration === 0 ? '00:00:00' : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                    sortable
                    filterPlaceholder="Введіть час"
                    filter
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterField="fullCallDuration"
                    filterElement={fullCallDurationFilterTemplate}
                />;
                break;
            case "duration":
                itemName = <Column
                    key={i}
                    header={renderHeader('Тривалість розмови', 'Duration')}
                    className="justify-content-start"
                    body={(data) => data?.item?.duration && data?.item?.duration !== -1 ? convertSecondsToTime(data?.item?.duration) : data?.item?.duration === 0 ? '00:00:00' : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                    sortable
                    filterPlaceholder="Введіть час"
                    filter
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterField="duration"
                    filterElement={durationFilterTemplate}
                />;
                break;
            case "reactionClient":
                itemName = <Column
                    key={i}
                    header={renderHeader('Реакція Клієнта', 'ReactionClient')}
                    className="justify-content-start"
                    body={(data) => data?.item?.reactionClient && data?.item?.reactionClient !== -1 ? convertSecondsToTime(data?.item?.reactionClient) : data?.item?.reactionClient === 0 ? '00:00:00' : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                    sortable
                    filterPlaceholder="Введіть час"
                    filter
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterField="reactionClient"
                    filterElement={reactionClientFilterTemplate}
                />;
                break;
            case "reactionOperator":
                itemName = <Column
                    key={i}
                    header={renderHeader('Реакція Оператора', 'ReactionOperator')}
                    className="justify-content-start"
                    body={(data) => data?.item?.reactionOperator && data?.item?.reactionOperator !== -1 ? convertSecondsToTime(data?.item?.reactionOperator) : data?.item?.reactionOperator === 0 ? '00:00:00' : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                    sortable
                    filterPlaceholder="Введіть час"
                    filter
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterField="reactionOperator"
                    filterElement={reactionOperatorFilterTemplate}
                />;
                break;
            case "contactName":
                itemName = <Column
                    key={i}
                    // header={renderHeader('Реакція Оператора', 'ContactName')}
                    header="Контакт"
                    className="justify-content-start"
                    body={contactNameBodyTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                    // sortable
                    // filterPlaceholder="Введіть час"
                    // filter
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterField="reactionOperator"
                    filterElement={reactionOperatorFilterTemplate}
                />;
                break;
            case "ownerType":
                let foundOwnerType = (ownerTypeId: any) => {
                    let ownerType = ownerTypeDictionary?.filter((status: any) => status?.dictionaryId === ownerTypeId);
                    return ownerType?.[0]?.description;
                }

                itemName = <Column
                    key={i}
                    header={renderHeader('Тип власника', 'OwnerType')}
                    className="justify-content-start"
                    body={(data) =>  foundOwnerType(data?.item?.ownerType) || ''}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '170px'}}
                    sortable
                    filterPlaceholder="Виберіть власника"
                    filter
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterField="ownerType"
                    filterElement={ownerTypeFilterTemplate}
                />;
                break;
            case "end":
                itemName = <Column
                    key={i}
                    header={renderHeader('Завершення', 'End')}
                    className="justify-content-start"
                    body={(data) => data?.item?.end ? formatDateTime(data?.item?.end) : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '170px'}}
                    sortable
                    filterPlaceholder="Введіть час"
                    filter
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterField="end"
                    filterElement={dateEndFilterTemplate}
                />;
                break;
            default:
                itemName = itemName = <Column
                    key={i}
                    className="justify-content-start"
                    header={renderHeader('', '')}
                    body={''}
                />;
        }

        return itemName;
    }

    const secondLevelTableCase = (name: string, i: number) => {
        let itemName: any;
        switch (name) {
            case "ani":
                itemName = <Column
                    key={i}
                    className="justify-content-start"
                    field="item.ani"
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "contactName":
                itemName = <Column
                    key={i}
                    className="justify-content-start"
                    field="item.contactName"
                    body={contactNameBodyTemplate}
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "aNumber":
                itemName = <Column
                    key={i}
                    field="item.aNumber"
                    className="justify-content-start"
                    bodyClassName={(rowData) => rowData.item?.isMatchingSessionId ? 'your-custom-class' : ''}
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '150px'}}
                />;
                break;
            case "ownerUserName":
                itemName = <Column
                    key={i}
                    field="ownerUserName"
                    className="justify-content-start"
                    headerClassName='hidden'
                    body={typeBodyTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "fullName":
                itemName = <Column
                    key={i}
                    field="fullName"
                    className="justify-content-start"
                    headerClassName='hidden'
                    body={typeOperatorTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "direction":
                itemName = <Column
                    key={i}
                    className="justify-content-start"
                    field="direction"
                    headerClassName='hidden'
                    body={typeDirectionBodyTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "campaignFullName":
                itemName = <Column
                    key={i}
                    className="justify-content-start"
                    field="campaignId"
                    headerClassName='hidden'
                    body={campaignBodyTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "branchId":
                itemName = <Column
                    key={i}
                    className="justify-content-start"
                    field="branchId"
                    headerClassName='hidden'
                    body={branchBodyTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "queueFullName":
                itemName = <Column
                    key={i}
                    field="queueId"
                    className="justify-content-start queue-column"
                    body={queueBodyTemplate}
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "status":
                itemName = <Column
                    key={i}
                    className="justify-content-start status-column"
                    field="status"
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '150px'}}
                    body={renderStatusColumn}
                />;
                break;
            case "callType":
                itemName = <Column
                    key={i}
                    field="callType"
                    className="justify-content-start channel-column"
                    body={renderActivityColumn}
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '150px'}}
                />;
                break;
            case "ownerType":
                let foundOwnerType = (ownerTypeId: any) => {
                    let ownerType = ownerTypeDictionary?.filter((status: any) => status?.dictionaryId === ownerTypeId);
                    return ownerType?.[0]?.description;
                }

                itemName = <Column
                    key={i}
                    body={(data) =>  foundOwnerType(data?.item?.ownerType) || ''}
                    header={'Завершення'}
                    headerClassName='hidden'
                    className="justify-content-start"
                    style={{cursor: 'pointer', width: `100%`, minWidth: '170px'}}
                />;
                break;
            case "callResetName":
                itemName = <Column
                    key={i}
                    field="callResetName"
                    className="justify-content-start"
                    headerClassName='hidden'
                    body={callResetBodyTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '160px'}}
                />;
                break;
            case "forcedClosing":
                itemName = <Column
                    key={i}
                    field="forcedClosing"
                    className="justify-content-start"
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '180px'}}
                    body={amdHangupBodyTemplate}
                />;
                break;
            case "start":
                itemName = <Column
                    key={i}
                    field="item.start"
                    className="justify-content-start"
                    sortable
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '170px'}}
                />;
                break;
            case "fullCallDuration":
                itemName = <Column
                    key={i}
                    header={'Тривалість дзвінка'}
                    headerClassName='hidden'
                    className="justify-content-start"
                    body={(data) => data.item.fullCallDuration && data?.item?.fullCallDuration !== -1 ? convertSecondsToTime(data?.item.fullCallDuration) : data?.item?.fullCallDuration === 0 ? '00:00:00' : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "duration":
                itemName = <Column
                    key={i}
                    header={'Тривалість розмови'}
                    headerClassName='hidden'
                    className="justify-content-start"
                    body={(data) => data?.item?.duration && data?.item?.duration !== -1 ? convertSecondsToTime(data?.item?.duration) : data?.item?.duration === 0 ? '00:00:00' : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "reactionClient":
                itemName = <Column
                    key={i}
                    header={'Реакція Клієнта'}
                    headerClassName='hidden'
                    className="justify-content-start"
                    body={(data) => data?.item?.reactionClient && data?.item?.reactionClient !== -1 ? convertSecondsToTime(data?.item?.reactionClient) : data?.item?.reactionClient === 0 ? '00:00:00' : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "reactionOperator":
                itemName = <Column
                    key={i}
                    header={'Реакція Оператора'}
                    className="justify-content-start"
                    headerClassName='hidden'
                    body={(data) => data?.item?.reactionOperator && data?.item?.reactionOperator !== -1 ? convertSecondsToTime(data?.item?.reactionOperator) : data?.item?.reactionOperator === 0 ? '00:00:00' : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "end":
                itemName = <Column
                    key={i}
                    header={'Завершення'}
                    headerClassName='hidden'
                    className="justify-content-start"
                    body={(data) => data?.item?.end ? formatDateTime(data?.item?.end) : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '170px'}}

                />;
                break;
            default:
                itemName = itemName = <Column
                    key={i}
                    header={'Завершення'}
                    className="justify-content-start"
                    headerClassName='hidden'
                    body={''}
                />;
        }

        return itemName;
    }

    const rowExpansionBSessionTemplate = (data: DataRow) => {
        return (
            <DataTable
                value={data?.children}
                className="p-datatable-customers monitoring-table monitoring-table-td monitoring-Expansion"
                selectionMode="single"
                rowClassName={dynamicBSessionRowClass}
                selection={selectedBSessionRowExpansion}
                onRowClick={(e) => {
                    setSelectedRowData(null);
                    handleResetPlayer();
                    dispatch(getEventStatisticToUserDetail(e.data.item.id, jwtToken?.jwtToken));
                    if (!isMobile) {
                        if (props.profileMenuPin === true) {
                            setSelectedRowExpansion(e.data);
                            setVisible(true);
                        } else {
                            setSelectedRowExpansion(e.data);
                        }
                    } else {
                        setSelectedRowExpansion(e.data);
                        setVisible(true);
                    }
                }}
                dataKey="item.bSessionId"
            >
                <Column headerClassName={'hidden'} body={BSessionIcon}
                        style={{minWidth: '6rem', display: 'flex', alignItems: 'center', justifyContent: 'end'}}/>
                {renderTableColumns(secondLevelTableCase)}
            </DataTable>
        );
    };

    const sessionBodyIcon = (rowData: any) => {
        if (rowData?.children?.length) {
            return <></>
        }
    }

    const rowExpansionTemplate = (data: DataRow) => {
        return (
            <DataTable
                value={data?.children}
                className="p-datatable-customers monitoring-table monitoring-table-td monitoring-Expansion"
                selectionMode="single"
                selection={selectedSessionRowExpansion}
                rowExpansionTemplate={rowExpansionBSessionTemplate}
                expandedRows={expandedSessionRows}
                onRowToggle={(e) => setExpandedSessionRows(e.data)}
                onRowClick={(e) => {
                    handleResetPlayer();
                    dispatch(getEventStatisticToUserDetail(e.data.item.id, jwtToken?.jwtToken));
                    setSelectedRowData(null);
                    if (!isMobile) {
                        if (props.profileMenuPin === true) {
                            setSelectedRowExpansion(e.data);
                            setVisible(true);
                        } else {
                            setSelectedRowExpansion(e.data);
                        }
                    } else {
                        setSelectedRowExpansion(e.data);
                        setVisible(true);
                    }
                }}
                dataKey="item.bSessionId"
            >
                <Column rowReorderIcon={'pi pi-close'} headerClassName={'hidden'} expander={allowExpansion}
                        style={{minWidth: '4rem', display: 'flex', alignItems: 'center', justifyContent: 'end'}}/>
                <Column headerClassName={'hidden'} body={sessionBodyIcon} expander={allowExpansion}
                        style={{minWidth: '2rem', display: 'flex', alignItems: 'center', justifyContent: 'center'}}/>
                {renderTableColumns(secondLevelTableCase)}
            </DataTable>
        );
    };

    const allowExpansion = (rowData: DataRow) => {
        return rowData.children?.length || false;
    };

    const collapseAll = () => {
        setExpandedRows(null);
    };

    const dynamicRowClass = (data: { item: any; }) => {
        if (data?.item?.bSessionId === selectedRowData?.item?.bSessionId) {
            return 'mainRowMonitoringTable p-highlight';
        }
        return 'mainRowMonitoringTable';
    };

    const dynamicBSessionRowClass = () => {
        return 'BSessionRow';
    };

    const renderTable = () => {
        return (
            <div className="layout-dashboard">
                <div className="flex flex-wrap col-12 md:col-12">
                    <div
                        className={classNames('card widget-table mr-4 col-12 transition-duration-300 monitoring-table align-self-start monitoringLoader', {'': (selectedRowData || selectedRowExpansion) && !isMobile(), 'md:col-12': !(selectedRowData || selectedRowExpansion)})}>
                        <StatisticsListNav
                            profileMenuPin={!!props.profileMenuPin}
                            setAllTimeChecked={setAllTimeChecked}
                            allTimeChecked={allTimeChecked}
                            hasStartFilter={hasStartFilter} setHasStartFilter={setHasStartFilter}
                            setEndTime={setEndTime} endTime={endTime} startTime={startTime}
                            setStartTime={setStartTime} setFilterEndDateTime={setFilterEndDateTime}
                            filterEndDateTime={filterEndDateTime} setFilterDateTime={setFilterDateTime}
                            filterDateTime={filterDateTime}
                            userSortFields={userStatisticSortFields?.fields}
                            sortData={sortData}
                            resetSorting={handleReset}
                            toggleTab={toggleTab}
                            activeTab={activeTab}
                            toggleButtonActivity={toggleButtonActivity}
                            setToggleButtonActivity={setToggleButtonActivity}
                            activityChangedManuallyRef2={activityChangedManuallyRef2}
                            setActivity={setActivity}
                            activity={activity}
                        />
                        <DataTable
                            expandedRows={expandedRows}
                            onRowToggle={(e) => setExpandedRows(e.data)}
                            rowExpansionTemplate={rowExpansionTemplate}
                            scrollable
                            scrollHeight={(selectedRowData || selectedRowExpansion) && !isMobile() ? '40vh' : '70vh'}
                            ref={dataTableRef}
                            rows={10}
                            onSort={monitoringSort}
                            filters={clearFilters}
                            loading={loader}
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            value={formattedData}
                            className="p-datatable-customers monitoring-table monitoring-table-rowGroup"
                            rowClassName={dynamicRowClass}
                            selectionMode="single"
                            emptyMessage="Нічого не знайдено"
                            rowHover={false}
                            onFilter={customFilter}
                            lazy
                            onRowClick={(e) => {
                                setSelectedRowExpansion(null);
                                handleResetPlayer();
                                dispatch(getEventStatisticToUserDetail(e.data.item.id, jwtToken?.jwtToken));
                                if (!isMobile) {
                                    if (props.profileMenuPin === true) {
                                        setSelectedRowData(e.data);
                                        setVisible(true);
                                    } else {
                                        setSelectedRowData(e.data);
                                    }
                                } else {
                                    setSelectedRowData(e.data);
                                    setVisible(true);
                                }
                            }} dataKey="item.bSessionId"
                        >
                            <Column rowReorderIcon={'pi pi-close'} expander={allowExpansion}
                                    style={{minWidth: '6rem'}}/>
                            {renderTableColumns(firstLevelTableCase)}
                        </DataTable>
                        <Paginator
                            first={first}
                            rows={paginationSize}
                            totalRecords={totalItems}
                            rowsPerPageOptions={[5, 10, 15, 25, 50]}
                            onPageChange={onPageChange}
                            className="border-top-1 border-bottom-1"
                            template="PrevPageLink PageLinks NextPageLink RowsPerPageDropdown"
                        />
                    </div>
                    {(selectedRowData || selectedRowExpansion) && statisticData && (
                        <>
                            {windowWidth > 1248 && <div
                                className={classNames('card widget-table col-12 md:col-12 align-self-start sticky top-0')}>
                                <StatisticsListDetails setSelectedRowData={setSelectedRowData}
                                                       setSelectedRowExpansion={setSelectedRowExpansion}
                                                       handleResetPlayer={handleResetPlayer}/>
                            </div>}

                            {windowWidth <= 1248 && <div>
                                <Dialog visible={visible} className="monitoring-info" onHide={() => setVisible(false)}>
                                    <StatisticsListDetails setSelectedRowData={setSelectedRowData}
                                                           setSelectedRowExpansion={setSelectedRowExpansion}
                                                           handleResetPlayer={handleResetPlayer}/>
                                </Dialog>
                            </div>}
                        </>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div>
            {renderTable()}
        </div>
    );
};

export default StatisticsList;
